const de = {
  common: {
    pagination: {
      previous: 'Zurück',
      next: 'Weiter',
      pageIndicator: 'Seite {currentPage} von {totalPages}',
    },
    buyerPlusImgAlt: 'Suchen+ für Kauf',
    mieterPlusImgAlt: 'Suchen+ für Miete',
    branding: {
      living: 'Wohnen',
      search: 'Suchen',
      searchForRenting: 'für Miete',
      searchForBuying: 'für Kauf',
    },
    labels: {
      mandatoryField: '*Pflichtfeld',
    },
    buttons: {
      close: 'Schließen',
      previous: 'Zurück',
      next: 'Weiter',
      backToOverview: 'Zur Übersicht',
      discoverWohnenPlus: 'Wohnen+ entdecken',
    },
    copy: 'Kopieren',
    copied: 'Kopiert',
    navigationLinks: {
      buying: 'Kaufen',
      renting: 'Mieten',
      living: 'Wohnen',
    },
    errorMessages: {
      inputRequired: 'Eingabe erforderlich',
      invalidEmailFormat: 'Ungültige E-Mail-Adresse',
      invalidDate: 'Ungültiges Datum',
      invalidPhoneNumber: 'Ungültige telefonnummer',
    },
    salutation: {
      female: 'Frau',
      male: 'Herr',
      other: 'Divers',
    },
    aragModal: {
      statusMessage: {
        missingDetails: {
          headline: 'Fehlende Daten',
          message: 'Bitte füge deine Daten in dem untenliegenden Formular hinzu',
        },
        pendingError: {
          headline: 'In Bearbeitung',
          message: 'Deine Anfrage wird gerade bearbeitet. Bitte habe einen Moment Geduld.',
        },
        updateDetailsError: {
          headline: 'Das hat leider nicht funktioniert',
          message:
            'Es liegt ein technischer Fehler vor. Bitte versuche die Änderung zu einem anderen Zeitpunkt vorzunehmen,',
        },
      },
      aragDetails: {
        image: 'ARAG Logo',
        companyName: 'ARAG SE',
        addressLine1: 'ARAG-Platz 1',
        addressLine2: '40472 Düsseldorf',
      },
      insuranceDetails: {
        customerNumber: 'Deine Kundennummer:',
        address: 'Deine Anschrift',
        contact: {
          key: 'Kontaktdaten für den Notfall',
          phoneNumber: {
            mietrechtsschutz: '0211 98901886',
            mediation: '0211 98901886',
            rechtsberatung: '0211 9933399',
            schluesseldienst: '0211 98901405',
          },
          availability: 'Täglich rund um die Uhr erreichbar',
          eMail: 'service@arag.de',
        },
        documents: {
          key: 'Dokumente',
          certificate: 'Versicherungsausweis',
          conditions: 'Versicherungsbedingungen',
          link: {
            s: 'https://www.arag-kooperationen.de/wps',
            m: 'https://www.arag-kooperationen.de/wpm',
            l: 'https://www.arag-kooperationen.de/wpl',
          },
        },
      },
      form: {
        customerNumber: 'Deine Kundennummer',
        policyNumber: 'Deine Versicherungsnummer',
        address: 'Deine Anschrift',
        edit: 'ändern',

        saveButtonText: 'Speichern',
        cancelButtonText: 'Abbrechen',
        city: {
          label: 'Ort',
          placeholder: '',
        },
        salutation: {
          label: 'Anrede',
          options: {
            female: 'Frau',
            male: 'Herr',
            neutral: 'Divers',
          },
        },
        firstName: {
          label: 'Vorname',
          placeholder: '',
        },
        lastName: {
          label: 'Nachname',
          placeholder: '',
        },
        street: {
          label: 'Straße',
          placeholder: '',
        },
        houseNumber: {
          label: 'Hausnr.',
          placeholder: '',
        },
        postcode: {
          label: 'PLZ',
          placeholder: '',
        },
      },
    },
  },
  issuePage: {
    headline: 'Da ist leider etwas schief gelaufen',
    unknown: {
      illustration: 'Sehr unglückliche Steckdose',
      message:
        'Vielleicht lag es an einer schlechten Internet-Verbindung oder temporären technischen Überlastung. Bitte versuche es später noch einmal.<br/><br/>Vielen Dank für dein Verständnis!',
      link: 'Erneut versuchen',
    },
    not_found: {
      illustration: 'Lupe als Illustration',
      message:
        'Bitte überprüfe die Schreibweise der Internetadresse (Groß-/Kleinschreibung) und/oder die Aktualität deines Lesezeichens.<br/><br/>Vielen Dank für dein Verständnis!',
      link: 'Zurück',
    },
    benefit_page_error: {
      illustration: 'Lupe als Illustration',
      message:
        'Dieser Service ist zurzeit nicht verfügbar, wir arbeiten an einer Lösung. Bitte versuche es später erneut.',
      link: 'Zurück',
    },
  },
  headArea: {
    headline: 'Mein',
    plus: 'Plus',
  },
  benefitsFilters: {
    headline: 'Meine',
    headline2: {
      buying: 'Vorteile für Kauf',
      renting: 'Vorteile für Miete',
      living: 'Vorteile',
    },
    filters: {
      search: 'Suchen',
      buy: 'Kaufen',
      living: 'Wohnen',
    },
    errorMessage:
      'Einige der {benefit} Services sind zurzeit nicht verfügbar, wir arbeiten an einer Lösung. Vielen Dank für dein Verständnis.',
  },
  benefitCardStatus: {
    lightOnly: 'nur mit Vollversion',
    common: {
      activated: 'Aktiviert',
      notActivated: 'Aktivierung erforderlich',
    },
    deposit: {
      activated: 'Aktiviert',
      rejected: 'Abgelehnt',
      pending: 'In Prüfung',
      notActivated: 'Aktivierung erforderlich',
      cancelled: 'Gekündigt',
      amountReduced: 'Kautionssumme reduziert',
    },
    schufa: {
      stored: 'Hinterlegt',
      expired: 'Abgelaufen',
    },
    billcheck: {
      actionRequired: 'Handlung erforderlich',
      done: 'Abgeschlossen',
      pending: 'In Prüfung',
    },
    insurance: {
      pending: 'Aktivierung ausstehend',
    },
  },
  documents: {
    sectionTitle: 'Deine Wohngeschichte',
    sectionSubtitle: 'Dokumentiere deine Wohnsituation',
    item: {
      uploadCta: 'Jetzt hochladen',
      additionalDocumentLabel: 'Weiteres Dokument',
      rentalContractCancelMessage: 'Mit unserer Kündigungsvorlage kannst du ganz einfach dein Mietverhältnis kündigen',
      rentalContractCancelButton: 'Kündigung erstellen',
      cancelationModalTitle: 'Mietvertrag kündigen',
      cancelationModalContentTitle: 'Möchtest du dein Mietverhältnis zeitnah kündigen?',
      cancelationModalContentText:
        'Passe dieses Vorlage mit wenigen Klicks an und schicke deine Kündigung gleich raus.',
      cancelationModalContentTextCheck1: 'Rechtssicher kündigen',
      cancelationModalContentTextCheck2: 'Sofort als Download verfügbar',
      cancelationModalContentTextCheck3: 'Bereit zum Versand',
    },
    edit: {
      modalTitle: 'Dokument bearbeiten',
      uploadedOn: 'Hochgeladen am: {date}',
      tooltips: {
        preview: 'Vorschau',
        download: 'Herunterladen',
        delete: 'Löschen',
      },
      form: {
        typeLabel: 'Dokumentkategorie',
        successEditMessage: 'Dokument erfolgreich bearbeitet',
      },
      delete: {
        modalTitle: 'Dokument löschen',
        modalText: 'Möchtest du dieses Dokument wirklich löschen?',
      },
    },
    errors: {
      uploadError: 'Das Dokument konnte nicht hochgeladen werden.',
      deleteError: 'Das Dokument konnte nicht gelöscht werden.',
      editError: 'Das Dokument konnte nicht bearbeitet werden.',
    },
    type: {
      RENTAL_CONTRACT: 'Mietvertrag',
      RENTAL_DEPOSIT: 'Mietkaution',
      HANDOVER_PROTOCOL: 'Übergabeprotokoll',
      UTILITY_COSTS: 'Nebenkosten',
      FLOOR_PLAN: 'Grundriss',
      INTERNET: 'Internet',
      TERMINATION: 'Kündigung',
      RENT_INCREASE: 'Mieterhöhung',
      ELECTRICITY_BILL: 'Stromrechnung',
      OTHER: 'Anderes Dokument',
    },
  },
  benefits: {
    mieterNetzwerk: {
      headline: 'Mieter-Netzwerk',
      modal: {
        headline: 'Mieter-Netzwerk',
        image: 'Mieter-Netzwerk',
        overview: {
          paragraph1: 'Entdecke unveröffentlichte Wohnungsangebote im Mieter-Netzwerk.',
          paragraph2:
            'Werde Teil des Mieter-Netzwerks und erfahre, wer gerade auch nach einer neuen Bleibe sucht und welche Wohnungen bald verfügbar werden.',
        },
        activeMieterPlus: 'In {Logo} für Miete enthalten ',
        cta: {
          ELIGIBLE: 'Mieter-Netzwerk beitreten',
          DRAFT: 'Angebot finalisieren',
          editImmos: "Bearbeiten unter 'Meine Immos'",
          startSearch: 'Jetzt mit der Suche starten',
          discoverSuchenPlus: 'Suchen+ entdecken',
        },
        faq: {},
      },
    },
    warteliste: {
      headline: 'Warteliste',
      modal: {
        headline: 'Warteliste',
        image: 'Warteliste',
        overview: {
          paragraph1:
            'Mit Wartelisten können Vermieter:innen dein Interesse sehen und dich schon vor der Veröffentlichung eines Inserats kontaktieren.',
          paragraph2:
            'Die Funktion nutzt deine gespeicherte Suche und bezieht derzeit deaktivierte Inserate ein. Wird ein Objekt wieder verfügbar, können Vermieter:innen dich direkt anschreiben – ohne ein neues Inserat erstellen zu müssen.',
        },
        activeMieterPlus: 'In {Logo} für Miete enthalten ',
        linkButton: 'Suchen+ entdecken',
        linkButtonPlusCta: 'Jetzt Suchkriterien anpassen',
        faq: {},
      },
    },
    magentaTv: {
      headline: 'MagentaTV Vorteil',
      modal: {
        image: 'Magenta TV',
        buttonCta: {
          claimVoucher: 'Gutschein holen',
          redeemVoucher: 'Gutschein einlösen',
          explore: '{product} entdecken',
        },
        voucher: {
          title: 'Dein persönlicher Gutscheincode:',
          subtitle: 'Kopiere deinen Gutscheincode und löse ihn bis zum 31.12.2026 ein.',
          errorMessage:
            '<p>Aktuell sind keine Gutscheincodes verfügbar. </p> <br> <p> Bitte versuche es später noch einmal.</p>',
          disclaimer: 'Hinweis: Du kannst nur einen Gutscheincode erstellen.',
        },
        overview: {
          headline: 'MagentaTV – einzigartige Entertainmentvielfalt, flexibel wie nie!',
          paragraph1:
            'Ob TV, Smartphone, Tablet oder Laptop: Erlebe mit MagentaTV Flex Fernsehen & Streaming überall und jederzeit. Für Dich jetzt mit 15% Rabatt*',
          bullet1: 'Große Sendervielfalt mit über 160 HD-Sendern',
          bullet2: 'Filme und Serien bei MagentaTV+ inklusive',
          bullet3: 'Mehr Komfort dank Restart, Timeshift oder Aufnahmefunktion',
          bullet4: 'Streamingdienste wie z.B. Netflix oder Disney+ zubuchbar',
          bullet5: 'Nur 8,50€ mtl., monatlich kündbar, nutzbar an jedem Internetanschluss',
          starredInfo: '* Es gelten die Nutzungsbedingungen.',
        },
        howItWorks: {
          image1: 'Magenta TV',
          image2: 'Magenta TV',
          image3: 'Magenta TV',
          step1:
            'Erstelle dir über “Gutschein holen” den Gutscheincode. Kopiere diesen und klicke auf „Code kopieren und Gutschein einlösen“',
          step2: 'Füge MagentaTV Flex zum Warenkorb hinzu und ergänze deinen Gutscheincode am Ende der Übersicht',
          step3: 'Gehe zur Kasse, schließe den Bestellvorgang ab und genieße MagentaTV',
        },
        faq: {
          item0: {
            question: 'Was beinhaltet MagentaTV?',
            answer: `<ul>
            <li>Über 180 Sender, davon über 160 in HD</li>
            <li>Nutzung auf dem Fernseher sowie auf Smartphone, Tablet & Laptop, auf bis zu 3 Geräten gleichzeitig</li>
            <li>Mit der Restart- und Timeshift-Funktion die Sendezeit selbst bestimmen, mit der übergreifenden Suche Lieblingsinhalte schnell finden</li>
            <li>Bis zu 50 Std. in der Cloud speichern und zur Wunschzeit streamen</li>
            <li>Weitere Streamingdienste wie z.B. Netflix oder Disney+ jederzeit zubuchbar</li>
            <li>Mit MagentaMusik einzigartige Konzerte und Festivals wie z.B. das Lollapalooza oder Wacken live oder jederzeit auf Abruf erleben</li>
            </ul>`,
          },
          item1: {
            question: 'Wer kann den Gutschein für MagentaTV Flex einlösen?',
            answer: `<p>Der Gutschein ist nur für ImmoScout24 Plus-Mitglieder:innen gültig. Über den Button "Gutschein holen" kannst du als Plus-Mitglied deinen persönlichen Gutscheincode kopieren und für deine Bestellung nutzen.</p>`,
          },
          item2: {
            question: 'Wie kann ich MagentaTV unabhängig vom Internetanbieter buchen und mich registrieren?',
            answer:
              `<ol>
            <li>Lege MagentaTV Flex in den Warenkorb und gib am Ende der Zusammenfassung deinen persönlichen Gutscheincode ein.</li>
            <li>Richte dir ein Nutzerkonto ein. Dafür brauchst du eine E-Mail-Adresse und ein Passwort.</li>
            <li>Gib eine Zahlungsart an.</li>
            <li>Bestelle zahlungspflichtig und starte dein TV-Streaming.</li>
            </ol>` +
              '<br></br>' +
              '<p><strong>Wichtig:</strong> Solltest du bereits einen Festnetz- und Internetanschluss bei der Telekom haben und über einen Telekom Login verfügen, lege bitte, damit du vom Gutscheincode Gebrauch machen kannst, unbedingt einen neuen Login mit einer anderen E-Mail-Adresse an. Bitte gib auch ein anderes Zahlungsmittel als bei deinem bisherigen Vertrag an.</p>',
          },
          item3: {
            question: 'Wie kann ich MagentaTV unabhängig vom Internetanbieter kündigen?',
            answer:
              'Zunächst loggst du dich im „Kundencenter“ ein. Dort findest du unter dem Reiter „Zusatzprodukte ohne Vertragsbezug“ den Button „Produkte verwalten“. Darüber gelangst du zu deiner persönlichen Produktübersicht. In dem Menü links klickst du auf „Verträge“ und wählst dort deinen MagentaTV Vertrag mit dem Button „Vertragsdetails“ aus. Hier besteht für dich dann die Möglichkeit, deinen MagentaTV Vertrag zu kündigen.',
          },
          item4: {
            question: 'Welche Kündigungsfristen muss ich bei MagentaTV Flex unabhängig vom Internetanbieter beachten?',
            answer: 'Die Flex-Tarife kannst du jederzeit mit einer Frist von 1 Monat kündigen.',
          },
          item5: {
            question: 'Wo erhalte ich weitere Informationen?',
            answer: 'Mehr Infos unter <a>MagentaTV mit MagentaTV App buchen | Telekom</a>',
            redirectionUrl: 'http://telekom.de/magenta-tv-mit-app',
          },
        },
        customerService: {
          headline: 'Weitere Fragen?',
          description: 'Der Telekom-Kundenservice hilft dir gerne persönlich weiter',
          problemPhoneNumber: {
            number: '0800 33 01000',
            text: 'MagentaTV Störung & Login-Probleme',
          },
          servicePhoneNumber: {
            number: '0800 33 04000',
            text: 'MagentaTV Beratung',
          },
        },
        termsOfService: {
          bullet1:
            'Registrierte Nutzer:innen von Suchen+ für Miete, Wohnen+ oder Suchen+ für Kauf, die einen MagentaTV Gutschein in einem dieser Bereiche generiert haben, können mit Einsatz dieses Vouchercodes den MagentaTV Flex ab 1. März 2025 für monatlich 8,50€ anstatt 10,00 € buchen.',
          bullet2: 'Die Mindestvertragslaufzeit im MagentaTV Flex beträgt 1 Monat.',
          bullet3:
            'Diese Aktion ist nicht mit anderen Aktionen oder Gutscheinen kombinierbar und nur gültig für MagentaTV Neukund:innen.',
          bullet4:
            'MagentaTV ist über die MagentaTV App ohne zusätzliche Hardware empfangbar. Auf Wunsch kann die MagentaTV One für 5 €/Monat mit einer Mindestvertragslaufzeit von 12 Monaten erworben werden.',
          bullet5:
            'Voraussetzung für die Nutzung ist eine bestehende Internetverbindung. Für die Internetverbindung gelten die Bedingungen des jeweiligen Internetanbieters.',
          bullet6:
            'Bei Nutzung über das Mobilfunk-Datennetz erfolgt die Belastung des Datenvolumens beim jeweiligen Mobilfunk-Anbieter.',
          bullet7: 'Der Gutschein ist gültig bis 31.12.2026.',
        },
      },
    },
    rechtsberatung: {
      headline: 'Rechtsberatung',
      modal: {
        image: 'Neubau im Sonnenschein',
        overview: {
          entitled: {
            paragraph1: 'Du hast Fragen zum Thema Miet- und Immobilienrecht?',
            paragraph2:
              'Die Mietrechtsberatung der ARAG unterstützt dich mit telefonischer Erstberatung bis zu zwei mal pro Jahr.',
          },
          notEntitled: {
            paragraph1: 'Du hast Fragen zum Thema Miet- und Immobilienrecht?',
            paragraph2:
              'Die Mietrechtsberatung der ARAG unterstützt dich mit telefonischer Erstberatung bis zu zwei mal pro Jahr.',
            bullet1: 'Beratung von geprüften Anwälten der ARAG Assistance',
            bullet2: 'Telefonische Erstberatung für bis zu drei Mietrechtsfragen im Jahr',
            bullet3: 'In {BuyerPlusLogo} enthalten',
            bullet3Light: 'In {BuyerPlusLogo} S, M und L enthalten (Upgrade bald möglich)',
          },
        },
        howItWorks: {
          image1: 'Telefonhörer',
          image2: 'Waage',
          paragraph1:
            'Bei rechtlichen Problemen und Rechtsfragen in Zusammenhang mit Miet- und Immobilienrecht die ARAG via Telefon kontaktieren, um eine rechtliche fundierte Meinung einzuholen.',
          paragraph2: 'Die Kontaktdaten findest du in der Übersicht.',
        },
        faq: {},
        linkButton: 'Wohnen+ entdecken',
      },
    },
    schluesseldienst: {
      headline: 'Schlüsseldienst',
      modal: {
        image: 'Neubau im Sonnenschein',
        overview: {
          entitled: {
            paragraph1: 'Abgesichert im Ernstfall mit dem Schlüsselnotdienst der ARAG',
            paragraph2:
              'Schlüssel verloren? Mit dem ARAG Schlüsseldienst im Notfall sind bei Notöffnungen die Kosten bis 500€ abgedeckt.',
          },
          notEntitled: {
            paragraph1: 'Abgesichert im Ernstfall mit dem Schlüsselnotdienst der ARAG',
            paragraph2:
              'Schlüssel verloren? Mit dem ARAG Schlüsseldienst im Notfall sind bei Notöffnungen die Kosten bis 500€ abgedeckt.',
            bullet1: 'Bis zu zwei Fälle pro Jahr',
            bullet2: 'Maximal 500€ pro Fall abgedeckt bei Notöffnung',
            bullet3: 'In {BuyerPlusLogo} enthalten',
            bullet3Light: 'In {BuyerPlusLogo} S, M und L enthalten (Upgrade bald möglich)',
          },
        },
        howItWorks: {
          image1: 'Telefonhörer',
          image2: 'Waage',
          paragraph1: 'Melde einen Notfall telefonisch jederzeit bei der ARAG und erhalte sofort Hilfe.',
          paragraph2: 'Die Kontaktdaten findest du in der Übersicht.',
        },
        faq: {},
        linkButton: 'Wohnen+ entdecken',
      },
    },
    mietrechtsschutz: {
      headline: 'Mietrechtsschutz',
      modal: {
        image: 'Neubau im Sonnenschein',
        overview: {
          entitled: {
            paragraph1: 'Der Mietrechtsschutz unterstützt im Falle eines Rechtsstreits',
            paragraph2:
              'Wenn die telefonische Erstberatung und eine Mediation einen Konflikt nicht lösen kann, dann unterstützt der Mietrechtsschutz bei den nächsten Schritten.',
            info150: 'Hierfür wird eine Selbstbeteiligung von 150€ erforderlich.',
            infoFree: 'Dieser Service ist für dich kostenlos.',
          },
          notEntitled: {
            paragraph1: 'Der Mietrechtsschutz unterstützt im Falle eines Rechtsstreits',
            paragraph2:
              'Wenn die telefonische Erstberatung und eine Mediation einen Konflikt nicht lösen kann, dann unterstützt der Mietrechtsschutz bei den nächsten Schritten.',
            bullet1: 'Beratung von geprüften Anwälten der ARAG Assistance',
            bullet2: 'mit 150€ oder 0€ Selbstbeteiligung pro Fall wählbar',
            bullet3: 'In {BuyerPlusLogo} enthalten',
            bullet3Light: 'In {BuyerPlusLogo} M und L enthalten (Upgrade bald möglich)',
          },
        },
        howItWorks: {
          image1: 'Telefonhörer',
          image2: 'Waage',
          paragraph1:
            'Bei Rechtsproblem und Rechtsfragen in Zusammenhang mit Miet- und Immobilienrecht die ARAG via Telefon oder E-Mail kontaktieren.',
          paragraph2: 'Die Kontaktdaten findest du in der Übersicht.',
        },
        faq: {},
        linkButton: 'Wohnen+ entdecken',
      },
    },
    mediation: {
      headline: 'Mediation',
      modal: {
        image: 'Neubau im Sonnenschein',
        overview: {
          entitled: {
            paragraph1: 'Du benötigst Hilfe zur Konfliktbeilegung?',
            paragraph2: 'Die Mediation der ARAG unterstützt bei Streitigkeiten zwischen Mieter:in und Vermieter:in.',
          },
          notEntitled: {
            paragraph1: 'Du benötigst Hilfe zur Konfliktbeilegung?',
            paragraph2: 'Die Mediation der ARAG unterstützt bei Streitigkeiten zwischen Mieter:in und Vermieter:in',
            bullet1:
              'Die Mediation ist ein freiwilliges Verfahren zur Konfliktbeilegung zwischen Mieter:in und Vermieter:in',
            bullet2: 'Dies kann bis zu zwei mal pro Jahr für Streitigkeiten in Anspruch genommen werden',
            bullet3: 'In {BuyerPlusLogo} enthalten',
            bullet3Light: 'In {BuyerPlusLogo} S, M und L enthalten (Upgrade bald möglich)',
          },
        },
        howItWorks: {
          image1: 'Telefonhörer',
          image2: 'Waage',
          paragraph1:
            'Die Mediation hilft, um bei Streitigkeiten zwischen Mieter:in und Vermieter:in. zu unterstützen. Kontaktiere dazu die ARAG via Telefon oder E-Mail.',
          paragraph2: 'Die Kontaktdaten findest du in der Übersicht.',
        },
        faq: {},
        linkButton: 'Wohnen+ entdecken',
      },
    },
    consumerBenefitSchufa: {
      headline: 'Bonitätsauskunft',
      modal: {
        overview: {},
        faq: {},
      },
    },
    deposit: {
      headline: 'Mietkautionsbürgschaft',
      modal: {
        headline: 'Mietkautionsbürgschaft',
        overview: {
          image: 'Mietkautionsbürgschaft',
          overviewParagraph1: 'Umzugskisten von Turtlebox - die clevere Alternative zu Umzugskartons',
          overviewParagraph2: 'Die umweltfreundlichen Umzugsboxen zur Miete:',
          pendingText:
            'Dein Antrag ist bei der Allianz in der Bearbeitung. Dies nimmt gewöhnlich einen Werktag in Anspruch.',
          depositNotifications: {
            cancelation: {
              headline: 'Mietkautionsbürgschaft bei der Allianz gekündigt',
              messsage: 'Deine Mietkautionsbürgschaft bei der Allianz wurde zum {dateAt} beendet.',
            },
            reduction: {
              headline: 'Kautionssumme wurde reduziert',
              messsage: 'Die Kautionssumme wurde bei der Allianz reduziert',
            },
          },
          depositStatusFrame: {
            statusTitle: 'Bürgschaft bei der Allianz aktiv',
            sectionTitles: {
              customerNumber: 'Deine Kundennummer',
              depositStart: 'Beginn der Kautionsbürgschaf',
              depositAmount: 'Höhe der Kaution',
              monthlyContributionEntitled: 'Monatsbeitrag',
              monthlyContribution: 'Monatsbeitrag',
            },
            monthlyContributionEntitledInfo:
              'Nach Beendigung deiner Mieter-Plus-Mitgliedschaft entstehen für die Mietkautionsbürgschaft der Allianz Kosten in Höhe von 4,7% deiner Kautionssumme pro Jahr. Diese Kosten sind bis zur Rückgabe der Kautionsurkunde im Original über deine hinterlegte Zahlungsmethode an uns anteilig pro Monat zu bezahlen.',
            faqLinkText: 'Wie kann ich kündigen?',
          },
          rejectedStatus: {
            headline: 'Mietkautionsbürgschaft abgelehnt',
            message: 'Dein Antrag wurde von der Allianz abgelehnt.',
          },
          checkmarkList: {
            item1: 'Stabil, stapelbar und wetterfest',
            item2: 'Aus 100% recycelbarem Kunststoff',
            item3: 'Praktischer Liefer- und Abholservice',
            item4: '5% Rabatt, Mit {BuyerPlusLogo} 20% Rabatt',
          },
          discoutContainer: {
            title: 'Dein persönlicher {discountAmount}% Rabattcode',
            info1: 'Dein Rabattcode wird im Warenkorb automatisch eingelöst.',
            info2:
              'Deinen persönlichen Rabattcode kannst Du im Online-Shop von Turtlebox einmalig einlösen. Ein neuer Code wird nach 4 Wochen automatisch generiert.',
            info3:
              'Auf Fremdleistungen von Turtlebox wie Kurier- oder Speditionsleistungen kann der Rabatt leider nicht angerechnet werden.',
          },
          productDescription: {
            overviewHeadline: 'Komm du erstmal an - die Kaution ist schon da.',
            overviewParagraph1:
              'Eine Mietkautionsbürgschaft ist eine Alternative zu der klassischen Barkaution. Übergebe deinem:deiner Vermieter:in die Bürgschaftsurkunde der Allianz (max. Kautionssumme 5.000€), statt bis zu drei Monatsmieten Kaution zu zahlen.',
            overviewParagraph2:
              'Bei bereits gezahlter Kaution erhältst du ggf. von Vermieter:innen deine Barkaution zurück.',
            checkmark1: 'Keine Barkaution zahlen',
            checkmark2: 'Als kurz- oder langfristige Lösung',
            checkmark3: 'Keine Mindestvertragslaufzeit, keine Kündigungsfrist',
            checkmark4: 'In {badgeLabel} enthalten',
            tenant: 'Mieter',
          },
          customerService: {
            headline: 'Noch Fragen?',
            description: 'Der Allianz-Kundenservice hilft dir gerne persönlich weiter',
            phoneNumber: '0800 / 900 40 04',
            workingHours: 'Mo - Fr 8-21 Uhr und Sa 9-17 Uhr',
            email: 'allianz-mietkaution@kautionskasse.de',
          },
        },
        howItWorks: {
          image1: 'Rabattcoupon',
          image2: 'Umzugswagen',
          image3: 'Dolly-Wagen',
          description1: 'Antragsformular online ausfüllen und absenden.',
          description2: 'Versand der Bürgschaftsurkunde per Post am nächsten Werktag.',
          description3: 'Urkunde einfach bei Vermieter:innen vorlegen und Kaution sparen.',
        },
        faq: {
          item0: {
            question: 'Wie funktioniert die Allianz Mietkaution?',
            answer:
              '<p>Die Allianz verpflichtet sich mit Abschluss des Versicherungsvertrages gegenüber dem Vermieter für die vertraglich vereinbarte Kautionssumme zu bürgen. Der Mieter erhält nach Abschluss des Vertrages eine Bürgschaftsurkunde zur Übergabe an den Vermieter.</p><p>Verlangt der Vermieter berechtigt Zugriff auf die Mietsicherheit (im Schadenfall), so tritt die Allianz zunächst für den Mieter ein und die Kautionsforderung wird unverzüglich gezahlt. Die Allianz nimmt dann beim Mieter Regress. Unterstützt wird sie hierbei von einem Inkassodienstleister, der sich auf ein professionelles Forderungsmanagement spezialisiert hat.</p>',
          },
          item1: {
            question:
              'Eignet sich die Allianz Mietkaution auch für einen kurzen Zeitraum, z.B. als Zwischenfinanzierung?',
            answer:
              '<p>Ja, der Mieter kann die Allianz Mietkaution auch für einen kurzen Zeitraum nutzen. Da das Produkt jederzeit durch Rückgabe der Bürgschaftsurkunde beendet werden kann, ist es auch als Zwischenfinanzierung denkbar.</p>',
          },
          item2: {
            question: 'Was ist eine Bürgschaft auf erstes Anfordern?',
            answer:
              '<p>Auf erstes Anfordern heißt: Der Bürgschaftsgeber muss grundsätzlich auf Anforderung des Vermieters und einer angemessenen Prüffrist (für die Stellungnahme des Mieters) an den Vermieter auszahlen. Sofern die formalen Voraussetzungen aus dem Bürgschaftsvertrag erfüllt sind, kann der Mieter eine Auszahlung nur noch verhindern, indem er einen offensichtlichen Rechtsmissbrauch des Vermieters zweifelfrei nachweist.</p>',
          },
          item3: {
            question: 'Welche Rolle spielt die Deutsche Kautionskasse im Rahmen des Versicherungsvertrages?',
            answer:
              '<p>Die Deutsche Kautionskasse AG (DKK) ist als Dienstleister für die Allianz Versicherungs-AG mit der Verwaltung der Mietkautionsversicherung betraut. Die DKK übernimmt sowohl die Antrags-, Bestands- als auch die Schadenbearbeitung.</p>',
          },
          item4: {
            question: 'Wer kann die Allianz Mietkaution abschließen?',
            answer:
              '<p>Die Allianz Mietkaution können ausschließlich natürliche Personen in ihrer Eigenschaft als Mieter einer privat genutzten und in Deutschland gelegenen Wohneinheit abschließen. Der Vermieter selbst kann dies grundsätzlich nicht.</p>',
          },
          item5: {
            question: 'Wer und was ist bei der Allianz Mietkaution versichert?',
            answer:
              '<p>Versichert ist das Risiko des Vermieters, dass der Mieter seine Zahlungsverpflichtungen aus dem Mietverhältnis nicht ordnungsgemäß erfüllt. Der Vermieter kann dann gesetzlich berechtigt sein auf die Mietkaution zuzugreifen (Leistungsfall), z.B. wegen fälliger Mieten oder Schäden am Mietobjekt.</p>',
          },
          item6: {
            question: 'Wie gestalten sich Zahlungsweise und Laufzeit?',
            answer:
              '<p>Erst nach Beendigung der Suchen+ für Miete Mitgliedschaft entstehen für die Mietkautionsbürgschaft der Allianz Kosten in Höhe von 4,7 % der Kautionssumme pro Jahr. Diese Kosten sind bis zur Rückgabe der Kautionsurkunde im Original über die hinterlegte Zahlungsmethode an ImmoScout24 anteilig pro Monat zu bezahlen.</p>',
          },
          item7: {
            question: 'Welche Angaben werden für die Antragsstellung benötigt?',
            answer:
              '<ul><li>Mieterdaten (gemäß Mietvertrag)</li><li>Daten zum Mietobjekt (gemäß Mietvertrag)</li><li>Daten zum Vermieter (gemäß Mietvertrag)</li><li>Datum des Mietbeginns</li><li>Angaben zur Bankverbindung eines in Deutschland vertretenen Geldinstituts</li><li>gegebenenfalls eine Kopie des Personalausweises oder Mietvertrages</li></ul>',
          },
          item8: {
            question: 'Gibt es eine Mindestvertragslaufzeit?',
            answer: '<p>Nein, für die Allianz Mietkaution gibt es keine Mindestlaufzeit.</p>',
          },
          item9: {
            question: 'Wie lange dauert die Widerrufsfrist?',
            answer:
              '<p>Innerhalb von 14 Tagen nach Erhalt der Vertragsunterlagen kann der geschlossene Vertrag in Textform (z.B. Brief, E-Mail) widerrufen werden. Zur endgültigen Abwicklung, insbesondere der Aufhebung der Zahlungspflicht, muss der Deutschen Kautionskasse die Original-Bürgschaftsurkunde zurückgesendet werden (Stichtag: Eingangsdatum der Urkunde):</p>' +
              '<p>Deutsche Kautionskasse AG</p><p>Allianz Mietkaution</p>' +
              '<p >Gautinger Str. 10</p>' +
              '<p >82319 Starnberg</p>',
          },
          item10: {
            question: 'Warum ist die Urkunde bei einem Widerruf im Original zurückzusenden?',
            answer:
              '<p>Die Bürgschaftsurkunde verbrieft das Bürgschaftsversprechen gegenüber dem Vermieter. Mit Aushändigung der Original-Urkunde an den Vermieter (Bürgschaftsbegünstigter), erlangt diese als Mietsicherheit die volle Gültigkeit (ab dem auf der Urkunde notierten Bürgschaftsbeginn).</p><p>Solange die Original-Bürgschaftsurkunde nicht an unseren Dienstleister, die Deutsche Kautionskasse, zurückgegeben wird, ist davon auszugehen, dass diese ihrem eigentlichen Sicherungszweck, der Stellung der Mietkaution, dient.</p>',
          },
          item11: {
            question: 'Wie hoch ist der Versicherungsbeitrag?',
            answer:
              '<p>Erst nach Beendigung deiner Mieter-Plus-Mitgliedschaft entstehen für die Mietkautionsbürgschaft der Allianz Kosten in Höhe von 4,7 % deiner Kautionssumme pro Jahr. Diese Kosten sind bis zur Rückgabe der Kautionsurkunde im Original über deine hinterlegte Zahlungsmethode an uns anteilig pro Monat zu bezahlen.</p>',
          },
          item12: {
            question: 'Beitragszahlung, wofür ist diese?',
            answer:
              '<p>Der jährliche zu zahlende Beitrag für die Allianz Mietkaution ist für die Haftungsübernahme der Allianz Versicherungs-AG als Bürgschaftsgeberin gegenüber dem Vermieter zu zahlen.</p><p>Wichtig: Die Mietkautionsbürgschaft ist kein Finanzierungsinstrument. Der Mieter zahlt keine Mietkaution ab oder spart diese an.</p>',
          },
          item13: {
            question: 'Wann beginnt der Versicherungsschutz? Ab wann ist der Vermieter abgesichert?',
            answer:
              '<p>Den vollen Versicherungsschutz genießt der Vermieter mit Besitz der Original-Bürgschaftsurkunde, frühestens jedoch ab dem darauf ausgewiesenen Zeitpunkt.</p>',
          },
          item14: {
            question: 'Sind Änderungen an der Bürgschaftsurkunde möglich?',
            answer:
              '<p>Bei nicht risikorelevanten Schreibfehler kann eine korrigierte Urkunde ausgestellt werden. Hierzu muss die Original-Bürgschaftsurkunde samt der Änderungswünsche per Post an folgende Anschrift geschickt werden:</p><p>Deutsche Kautionskasse AG</p><p>Allianz Mietkaution</p><p>Gautinger Straße 10</p><p>82319 Starnberg</p><p>Sind risikorelevante Angaben falsch, ist der Vertrag durch Rückgabe der Original-Urkunde zu beenden und ein neuer Antrag zu stellen.</p>',
          },
          item15: {
            question: 'Verlust der Bürgschaftsurkunde, was ist zu tun?',
            answer:
              '<p>Bei Verlust ist eine von Mieter und Vermieter unterzeichnete Verlusterklärung (Formblatt) erforderlich. Nach Erhalt der Mitteilung wird kostenlos eine Ersatzurkunde ausgestellt bzw. bei Widerruf oder Kündigung der Vertrag beendet. Die als Verlust gemeldete Bürgschaftsurkunde verliert damit ihre Gültigkeit.</p>',
          },
          item16: {
            question: 'Wie hoch ist die Versicherungssumme?',
            answer:
              '<p>BDie Versicherungssumme entspricht der abgesicherten Kautionssumme. Die versicherbare Kautionssumme richtet sich nach gesetzlichen Vorgaben (§551). So darf der Vermieter maximal eine Sicherheit in Höhe der dreifachen Monatsmiete ohne Nebenkosten verlangen. Sofern diese Summe ausgezahlt wurde, erlischt der Versicherungsvertrag.</p>',
          },
          item17: {
            question: 'Was ist bei einer Kündigung zu beachten?',
            answer:
              '<p>Die Allianz Mietkaution kann jederzeit durch Rückgabe der Urkunde beendet werden. Die Zahlungspflicht endet mit Eingang der Original-Urkunde bei der Deutschen Kautionskasse.</p><p>Der Vertrag wird dann auf den Tag genau abgerechnet und zu viel entrichteter Beitrag anteilig erstattet. Eine Kündigungsbestätigung wird mit der Endabrechnung schriftlich versendet.</p><p>Eine Mindestvertragslaufzeit oder eine Kündigungsfrist gibt es nicht.</p>',
          },
          item18: {
            question: 'Was ist zu tun, wenn der Vermieter die Urkunde nicht aushändigt?',
            answer:
              '<p>Der Mieter muss den Vermieter zur Herausgabe der Urkunde mit Fristsetzung auffordern. Dabei ist zu beachten, dass der Vermieter eine Mietsicherheit erst nach Ablauf einer angemessenen Frist von 6 bis 12 Monaten ab Ende des Mietverhältnisses wieder herausgeben muss.</p><p>Sollte es keinen erkennbaren Grund für das Verhalten des Vermieters geben, sollte sich der Mieter rechtlich beraten lassen. In diesem Fall ist eine Immobilienrechtsschutzversicherung hilfreich</p>',
          },
          item19: {
            question: 'Kann die Höhe der Mietkaution bei Auszug reduziert werden?',
            answer:
              '<p>Ja, die Deutsche Kautionskasse benötigt hierzu ein Schreiben des Vermieters mit Angabe des Reduzierungswunsches, sowie die Original-Bürgschaftsurkunde.</p><p>Der Vertrag wird dann auf Basis der ursprünglichen Bürgschaftssumme taggenau abgerechnet und ein vorhandenes Guthaben anteilig mit dem Beitrag für die reduzierte Kautionssumme verrechnet (Stichtag: Eingangsdatum der Urkunde). Der Vermieter bekommt eine neue Urkunde welche er z.B. bis zum Zeitpunkt der Nebenkostenabrechnung einbehält.</p>',
          },
          item20: {
            question: 'Wann tritt der Versicherungsfall ein?',
            answer:
              '<p>Der Versicherungsfall tritt dann ein, wenn der Vermieter den Bürgschaftsbetrag ganz oder teilweise zur Auszahlung anfordert.</p>',
          },
          item21: {
            question: 'Was ist im Schadenfall zu tun?',
            answer:
              '<p>Der Vermieter sollte eine Inanspruchnahme der Allianz Mietkaution zeitnah bei der Deutschen Kautionskasse melden. Das Formular zur Inanspruchnahme kann telefonisch unter <strong>0800-900 30 20</strong> oder per E-Mail unter <strong> schaden-allianz-mietkaution@kautionskasse.de</strong> angefordert werden.</p><p>Das Formular muss vom Vermieter vollständig ausgefüllt, unterschrieben und zusammen mit der Bürgschaftsurkunde im Original sowie einer Kopie des Mietvertrages an die Deutsche Kautionskasse gesendet werden:</p><p>Deutsche Kautionskasse AG</p><p>Allianz Mietkaution</p><p>Gautinger Straße 10</p><p>82319 Starnberg</p><p>Bitte beachten Sie: Im Leistungsfall erhält der Versicherungsnehmer (Mieter) keine Zahlungen aus der Versicherung. Vielmehr muss er an den Vermieter ausgezahlte Beträge an uns zurückerstatten.</p><p>Hält der Mieter eine Forderung seines Vermieters für nicht gerechtfertigt, so muss er unter Umständen unverzüglich rechtliche Schritte gegen den Vermieter einleiten, um dessen Zugriff auf die Mietsicherheit zu unterbinden.</p>',
          },
          item22: {
            question: 'Welche Leistungen sind ausgeschlossen?',
            answer:
              '<p>Der Versicherungsnehmer selbst hat keinen Anspruch auf (Geld-)Zahlungen aus dem Versicherungsvertrag. Die Zahlungspflicht des Bürgschaftsgebers besteht nur gegenüber dem Vermieter und nur bis zur Höhe der vereinbarten Kautionssumme. Ausgeschlossen sind zudem Ansprüche des Vermieters, welche nach geltender Rechtslage nicht zum Zugriff auf die hinterlegte Mietsicherheit berechtigen.</p>',
          },
          item23: {
            question: 'Was passiert nach der Schadenmeldung durch den Vermieter?',
            answer:
              '<p>Sobald der Vermieter seine Ansprüche konkret beziffert hat, wird der Mieter informiert und zur Stellungnahme aufgefordert. Nach Ablauf der Stellungnahmefrist und Prüfung aller Unterlagen wird bei berechtigter Inanspruchnahme die angeforderte Summe an den Vermieter gezahlt. Dieser Ablauf dauert in der Regel ca. 14 Tage.</p><p>die Deutsche Kautionskasse über einen Schaden, erhält er ein Schadenformular mit der Bitte, dieses inklusive der angeforderten Unterlagen zurückschicken. Sobald diese Unterlagen vollständig vorliegen, wird der Mieter entsprechend informiert und zur Stellungnahme aufgefordert. Nach Ablauf der Stellungnahmefrist und Prüfung der Unterlagen wird die Kautionssumme an den Vermieter ausgezahlt.</p><p>Sollte der Mieter innerhalb der Stellungnahmefrist liquide Beweismittel für das Nichtbestehen des Anspruchs vorlegen oder sonstige Umstände, die für einen offensichtlichen Rechtsmissbrauch sprechen, wird die geforderte Kautionssumme nicht ausbezahlt.</p><p>Zu den liquiden Beweismitteln zählen rechtskräftige Urteile, sonstige Titel, Gutachten gerichtlich bestellter Sachverständiger und andere Urkunden. Einwendungen ohne Vorlage von liquiden Beweismitteln können regelmäßig nicht berücksichtigt werden.</p><p>Wichtig: nach Auszahlung an den Vermieter erhält der Mieter vom Bürgschaftsgeber eine Abrechnung und muss den ausgezahlten Betrag an diesen zurückzahlen.</p>',
          },
          item24: {
            question: 'Warum hat der Mieter nur wenig Zeit, sich zur Schadenmeldung zu äußern (Stellungnahmefrist)?',
            answer:
              '<p>Bei der Allianz Mietkaution handelt es sich um eine Bürgschaft auf erstes Anfordern, welche dem Vermieter als Mietsicherheit dient. Damit der Vermieter diese Art der Mietsicherheit akzeptiert, muss sichergestellt sein, dass er im Ernstfall genauso unkompliziert darauf zugreifen kann, wie auf eine andere Form der Mietsicherheit.</p><p>Es genügt daher bei dieser Art von Bürgschaft bereits die formale Anmeldung der Forderung und das Einreichen der Urkunde im Original zur Auszahlung. Eine beweisartige Darlegung des Anspruchs, wie wir es aus anderen Versicherungsprodukten kennen, wird nicht verlangt.</p><p>Fordert der Vermieter die Kaution ein, wird der Mieter wird unverzüglich schriftlich benachrichtigt. So hat der Mieter Gelegenheit, liquide Mittel zur Abwehr eines möglicherweise unrechtmäßigen Anspruchs einzureichen.</p>',
          },
          item25: {
            question:
              'Was passiert, wenn die Original-Bürgschaftsurkunde dem Vermieter im Schadenfall nicht mehr vorliegt?',
            answer:
              '<p>In diesem Falle ist eine vom Mieter und Vermieter unterzeichnete Verlusterklärung (Formblatt) erforderlich.</p>',
          },
          item26: {
            question: 'Fällt im Schadenfall eine Selbstbeteiligung an?',
            answer:
              '<p>Für den Vermieter fällt keine Selbstbeteiligung an. Der Mieter (Versicherungsnehmer) hingegen ist verpflichtet im Schadenfall aus der Bürgschaft an seinen Vermieter gezahlte Beträge vollständig an uns zurückzuerstatten.</p>',
          },
          item27: {
            question: 'Warum gehen wir nach Schadenzahlung auf den Mieter zu?',
            answer:
              '<p>Mit der Auszahlung an den Vermieter, erlangen wir Regressansprüche in Höhe des ausgezahlten Kautionsbetrags gegen den Mieter (Versicherungsnehmer). Der Mieter wird von der Deutschen Kautionskasse über die Zahlung an seinen Vermieter informiert und aufgefordert, den entsprechenden Betrag zu erstatten.</p>',
          },
        },
        activeButton: 'Mietkautionsbürgschaft aktivieren',
        buttonCta: {
          continueWithDiscount: 'Mit 5% Rabatt fortfahren',
          redeemDiscout: 'Rabatt einlösen',
        },
      },
    },
    relocationBox: {
      headline: 'Nachhaltige Umzugskisten',
      modal: {
        image: 'In Kartons verpackte Gegenstände',
        overview: {
          image: 'Umzugsboxen',
          overviewParagraph1: 'Umzugskisten von Turtlebox - die clevere Alternative zu Umzugskartons',
          overviewParagraph2: 'Die umweltfreundlichen Umzugsboxen zur Miete:',
          checkmarkList: {
            item1: 'Stabil, stapelbar und wetterfest',
            item2: 'Aus 100% recycelbarem Kunststoff',
            item3: 'Praktischer Liefer- und Abholservice',
            item4: '5% Rabatt, Mit {BuyerPlusLogo} 20% Rabatt',
          },
          discoutContainer: {
            title: 'Dein persönlicher {discountAmount}% Rabattcode',
            info1: 'Dein Rabattcode wird im Warenkorb automatisch eingelöst.',
            info2:
              'Deinen persönlichen Rabattcode kannst Du im Online-Shop von Turtlebox einmalig einlösen. Ein neuer Code wird nach 4 Wochen automatisch generiert.',
            info3:
              'Auf Fremdleistungen von Turtlebox wie Kurier- oder Speditionsleistungen kann der Rabatt leider nicht angerechnet werden.',
          },
        },
        howItWorks: {
          image1: 'Rabattcoupon',
          image2: 'Umzugswagen',
          image3: 'Dolly-Wagen',
          description1:
            'Rabattcode im Online-Shop von Turtlebox einlösen und Turtleboxen zum ausgewählten Termin abholen oder liefern lassen.',
          description2: 'Umweltfreundlich und sicher umziehen.',
          description3: 'Boxen zurückgeben oder von der neuen Adresse abholen lassen.',
        },
        faq: {
          item0: {
            question: 'Was sind die Vorteile von TURTLEBOX?',
            answer:
              '<strong>Nachhaltigkeit:</strong><br/>' +
              '<br/>' +
              '<ul>' +
              '<li>Zero-Waste Lösung: Turtleboxen sind sehr langlebig und werden mehr als 200 Mal wiederverwendet. Das entspricht einer Lebensdauer von über 10 Jahren.</li>' +
              '<li>Sie sparen Kartonage (und somit Ressourcen wie Holz, Wasser und Energie) ein und je Verwendung werden 87% CO2 eingespart*. Für das Konzept haben wir den Münchner Umweltpreis erhalten.</li>' +
              '</ul>' +
              '<br/><strong>Sicherheit:</strong><br/>' +
              '<br/>' +
              '<ul>' +
              '<li>Unsere Boxen schützen dein Hab und Gut optimal: Gegen Belastungen, Stöße, Feuchtigkeit und was nicht alles beim Umzug passieren kann.</li>' +
              '<li>Deine Sachen sind immer optimal geschützt, denn unsere Boxen sind stabiler als jeder Umzugskarton.</li>' +
              '</ul>' +
              '<br/><strong>Komfort:</strong><br/>' +
              '<br/>' +
              '<ul>' +
              '<li>Die Umzugsboxen lassen sich in wenigen Sekunden auf- und abbauen. Fang sofort mit dem Umzug an und spare dir Zeit beim Auspacken.</li>' +
              '<li>Unser praktischer Liefer- und Abholservice spart Dir Zeit und Arbeit. Du sparst Dir die Entsorgung von Kartons. Denn was macht man nach dem Umzug mit all den Umzugskartons?</li>' +
              '<li>Arbeiten wie ein Profi: Mit unseren multifunktionalen Rollern schiebst du anstatt zu tragen. In vielen Fällen eine große Erleichterung beim Umzug.</li>' +
              '</ul>',
          },
          item1: {
            question: 'Warum sind die Turtleboxen aus Kunststoff?',
            answer:
              '<strong>Kartonmüll durch eine Kunststoffbox vermeiden, macht das Sinn? Eine logische Frage, auf die wir eine logische Antwort haben: Das Material PP (Polypropylen) ist momentan die nachhaltigste Alternative für unser Umzugsboxen-System. Aus folgenden Gründen:</strong><br/>' +
              '<br/>' +
              '<ul>' +
              '<li>Langlebigkeit: Die Turtleboxen aus PP können sehr lange in unserem Miet-Kreislauf wiederverwendet werden, was sie umso nachhaltiger macht. Die Turtlebox hält weit mehr als 200 Umzügen stand und ersetzt somit erhebliche Mengen an Kartonage. Außerdem ist sie extrem bruchsicher.</li>' +
              '<li>Umweltbilanz: Vergleicht man die Herstellungs- und Recyclingbedingungen mit denen von alternativen Materialien, schneidet PP durch einen vergleichbar geringen Energieverbrauch und die hohe Recyclingfähigkeit am Besten ab. Turtleboxen werden zu 100% recycled.</li>' +
              '<li>Komfort: Turtleboxen sind leicht, trotzdem sehr stabil und optimal stapelbar.</li>' +
              '</ul>',
          },
          item2: {
            question: 'Was ist mein Vorteil als Suchen+ für Miete Mitglied?',
            answer:
              'Als Suchen+ für Miete und Vermieter+ bei ImmobilienScout24 erhältst du einen exklusiven Rabatt von 20% auf den Mietpreis deiner Umzugsboxen.<br/>' +
              '<br/>' +
              'Außerdem erhältst du nach deinem Umzug einen 5€ Gutschein zum Verschenken.',
          },
          item3: {
            question: 'Wie groß sind Turtleboxen?',
            answer:
              'Die Turtlebox ist mit einem Fassungsvermögen von rund 70 Litern mit einem Standard-Umzugskarton vergleichbar. Sie hat die Außenmaße 600x400x345 mm. Im zusammengeklappten Zustand hat sie nur noch eine Höhe von 7,5 cm.',
          },
          item4: {
            question: 'Wie lange kann ich Turtleboxen mieten?',
            answer:
              'Wir vermieten unsere Boxen immer wochenweise (Beispiel: Anmietung Freitag, Abgabe Freitag). Die kürzeste Mietdauer ist eine Woche, nach oben sind keine Grenzen gesetzt.',
          },
          item5: {
            question: 'Wie erhalte ich meine Turtleboxen?',
            answer:
              'Entweder du nutzt unseren praktischen Liefer- und Abholservice oder du holst die Boxen an einem unserer Standorte selber ab und bringst sie wieder zurück. Bei der Selbstabholung erhältst du einen zusätzlichen Rabatt.',
          },
        },
        buttonCta: {
          continueWithDiscount: 'Mit 5% Rabatt fortfahren',
          redeemDiscout: 'Rabatt einlösen',
        },
      },
    },
    relocationService: {
      headline: 'Umzugsservice',
      modal: {
        headline: 'Umzugsservice',
        image: 'Umzug',
        overview: {
          paragraph1: 'Kostenlose Angebote für deinen Umzug anfordern & entspannt vergleichen',
          paragraph2:
            'Vergleiche mit nur einer Anfrage bis zu 5 Umzugsangebote von Profis aus deiner Region. Der Vergleich lohnt sich, spare bis zu 42%.',
          bullet1: 'Schnell & einfach in nur 3min',
          bullet2: 'Finde geprüfte Umzugsfirmen',
          bullet3: 'Kostenlos und unverbindlich',
          alt: {
            paragraph1: 'Kostenlose Angebote für deinen Umzug anfordern',
            paragraph2:
              'Erhalte bis zu 5 unverbindliche Angebote von Umzugsfirmen aus deiner Region. Der Vergleich lohnt sich, denn du kannst bis zu 40% beim Umzug sparen.',
            bullet1: 'Exklusiver Rabatt für {MieterPlusLogo} Mitglieder!',
            bullet2: 'Suchen+ für Miete entdecken',
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'Waage',
          image3: 'Telefonhörer',
          paragraph1:
            'Erstelle deine Umzugsanfrage, indem du einfach Services angibst, die dir helfen, stressfrei in dein neues Zuhause zu ziehen.',
          paragraph1alt: 'Umzugsdaten angeben. Geben Sie die Wunschdaten zu Ihrem Umzug unkompliziert an.',
          paragraph2:
            'Wir finden für dich bis zu 5 passende Umzugsunternehmen, die mit dir schnell Kontakt aufnehmen und Angebote senden.',
          paragraph2alt: 'Professionelle Helfer finden. Wir finden die passenden Profis für Ihren individuellen Umzug.',
          paragraph3:
            'Vergleiche Umzugspreise und wähle das beste Angebot. Du willst noch mehr sparen? Setze deine Umzugskosten steuerlich ab.',
          paragraph3alt: 'Stressfrei umziehen. Ziehen Sie stressfrei und entspannt in Ihr neues Zuhause.',
        },
        faq: {
          item0: {
            question: 'Ist der Angebotsvergleich 100% unverbindlich und kostenlos?',
            answer:
              'Ja, unser Vergleichsservice ist für dich dauerhaft kostenlos und unverbindlich – auch wenn du nach deiner Anfrage kein Umzugsunternehmen beauftragen möchtest.',
          },
          item1: {
            question: 'Worauf sollte ich achten, wenn ich Umzugsangebote von Umzugsunternehmen vergleiche? ',
            answer:
              'Beim Vergleich von Umzugsangeboten ist es wichtig, auf die Gesamtkosten, enthaltene Leistungen, Versicherungsoptionen, Zusatzgebühren sowie Bewertungen und den Ruf des Umzugsunternehmens zu achten. Wir empfehlen dir mindestens 3 Angebote zu vergleichen. Bewertungen unserer Umzugspartner findest du  <a>hier</a>. ',
            redirectionUrl: 'https://www.umzugsfirmen-check.de/',
          },
          item2: {
            question: 'Wie weit im Voraus sollte ich meinen Umzug buchen?',
            answer:
              'Es ist ratsam, den Umzug so früh wie möglich zu buchen, vorzugsweise 6 bis 8 Wochen im Voraus. Dies ermöglicht eine bessere Planung und erhöht die Wahrscheinlichkeit, dass du den gewünschten Termin und günstigere Preise erhältst.',
          },
          item3: {
            question: 'Wie lange dauert ein Umzug mit Umzugsunternehmen?',
            answer:
              'Ein Umzug mit einem Unternehmen kann in einem Tag oder auch nur wenigen Stunden erledigt werden, insbesondere wenn es sich um lokale Umzüge handelt. Die exakte Dauer, ist dabei von dem gebuchten Serviceumfang wie z. B. Montage oder Demontage von Mobiliar abhängig.',
          },
          item4: {
            question: 'Weitere Fragen? ',
            answer: 'Falls du Fragen hast, findest du <a>hier</a> mehr Informationen zu unserem Umzugsservice.',
            redirectionUrl: 'https://www.umzugsfirmen-check.de/',
          },
        },
        linkButton: 'Unverbindliches Angebot anfordern',
      },
    },
    addressChange: {
      headline: 'Digitaler Adresswechsel',
      modal: {
        headline: 'Digitaler Adresswechsel',
        image: 'Digitaler Adresswechsel',
        overview: {
          START_PREMIUM: {
            paragraph1: 'Digitalen Adresswechsel starten',
            paragraph2:
              'Du ziehst bald um? Wir erkennen & benachrichtigen alle relevanten Empfänger über deinen Adresswechsel.',
            ctaText: 'Adresswechsel starten',
            bullet1: 'Alles digital, kein Papierkram',
            bullet2: 'Adresswechsel in unter 5 Minuten abgeschlossen',
            bullet3: 'Höchster Sicherheitsstandard bei der Datenbehandlung',
          },
          CONTINUE: {
            paragraph1: 'Digitalen Adresswechsel fortsetzen',
            paragraph2: 'Du hast bereits einen laufenden Adresswechsel. Schließe jetzt deinen Adresswechsel ab.',
            ctaText: 'Adresswechsel abschließen',
          },
          NOT_ELIGIBLE_USED_MP: {
            paragraph1: 'Adresswechsel aus Suchen+ für Miete 12 bereits genutzt',
            paragraph2:
              'Du hast deinen inkludierten Adresswechsel bereits genutzt. Du kannst weitere Adresswechsel einzeln erwerben.',
            ctaText: 'Adresswechsel kaufen',
            bullet1: 'Alles digital, kein Papierkram',
            bullet2: 'Adresswechsel in unter 5 Minuten abgeschlossen',
            bullet3: 'Höchster Sicherheitsstandard bei der Datenbehandlung',
          },
          NOT_ELIGIBLE: {
            paragraph1: 'Der digitale Adresswechsel ist in deiner Mitgliedschaft nicht enthalten',
            paragraph2:
              'Ziehst du bald um? Wir erkennen & benachrichtigen alle relevanten Empfänger über deinen Adresswechsel. Du kannst deinen Adresswechsel einzeln erwerben.',
            ctaText: 'Adresswechsel kaufen',
            bullet1: 'Alles digital, kein Papierkram',
            bullet2: 'Adresswechsel in unter 5 Minuten abgeschlossen',
            bullet3: 'Höchster Sicherheitsstandard bei der Datenbehandlung',
          },
        },
        faq: {},
      },
    },
    greenElectricity: {
      headline: 'KlarWatt Ökostrom',
      modal: {
        headline: 'KlarWatt Ökostrom',
        image: 'KlarWatt Ökostrom',
        overview: {
          paragraph1:
            'Exklusiver Wohnen+ Rabatt: In den ersten 12 Monaten keine Servicegebühr (statt 4,99 € pro Monat).',
          paragraph2:
            'Als Wohnen+ Mitglied profitierst du von einem exklusiven Rabatt auf KlarWatt, dem dynamischen Ökostromtarif von ImmoScout24. Durch tagesgenaue Börsenpreise sparst du bis zu 40 % – mit Preisbremse bei 37,89 Cent/kWh und monatlicher Kündigungsfrist.',
          ctaText: 'Jetzt Tarif mit Rabatt berechnen',
          discoverWohnenPlus: 'Wohnen+ entdecken',
        },
        faq: {},
      },
    },
    keyEmergency: {
      headline: 'Schlüsselnotdienst',
      modal: {
        faq: {},
        headline: 'Schlüsselnotdienst',
        image: 'Schlüsselnotdienst',
        overview: {
          paragraph1: 'Abgesichert im Ernstfall mit dem Schlüsselnotdienst der AXA Assistance',
          paragraph2:
            'Schlüssel verloren? Durch die AXA Assistance sind bei Notöffnung die Kosten bis zu 500 Euro abgedeckt.',
          bullet1: 'Sofortige Öffnung der Wohnungstür',
          bullet2: '24/7 für dich erreichbar',
          bullet3: 'Kosten bis max. EUR 500,- werden übernommen',
          bullet4: 'In {BuyerPlusLogo} enthalten',
          request: {
            keyEmergencyService: {
              title: 'Aktivierung erfolgreich',
              text: 'Der Schlüsselnotdienst wurde erfolgreich aktiviert.',
              insuranceStatus: {
                title: 'Service aktiv',
                deaktivieren: '(deaktivieren)',
                kundennummer: 'Deine Kundennummer',
                versicherungsnummer: 'Versicherungsnummer',
                anschrift: 'Deine Anschrift',
                kontaktdaten: 'Kontaktdaten für den Notfall',
                dokumente: 'Dokumente',
                cancellationText: 'Bist du sicher, dass du die Schlüsselnotdienst deaktivieren möchtest?',
                cancellationButton: 'Deaktivieren',
                cancellationButtonCancel: 'Abbrechen',
                edit: 'ändern',
                customerService: {
                  phoneNumber: '0221 80247 1360',
                  phoneNumberText: ' Täglich rund um die Uhr erreichbar',
                  email: 'immobilienscout24@axa-assistance.de',
                },
              },
              axaFooter: {
                title: 'Du hast deinen Schlüssel verloren und benötigst Hilfe?',
                text: 'Mit dem Schlüsselnotdienst der AXA werden Kosten bis max. EUR 500,- übernommen.',
                companyName: 'Inter Partner Assistance Service GmbH',
                companyStreet: 'Große Scharmstraße 36',
                companyCity: '15230 Frankfurt (Oder)',
              },
            },
            title: 'Aktivierung erforderlich',
            description: 'Du musst den Schlüsselnotdienst vorab abschließen, damit du im Notfall abgesichert bist.',
            customerService: {
              headline: 'Noch Fragen?',
              text: 'Der LAGERBOX-Kundenservice hilft dir gerne persönlich weiter',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mo - Fr 8-21 Uhr',
              businessHoursWeekend: 'Sa 9-17 Uhr',
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'Waage',
          image3: 'Telefonhörer',
          paragraph1: 'Schlüsselnotdienst zuvor online in unter 2 Minuten aktivieren und Kontaktdaten erhalten.',
          paragraph2: 'Notfall bei der AXA Assistance jederzeit telefonisch melden.',
          paragraph3:
            'AXA Assistance organisiert das Öffnen der Wohnungstür durch einen Schlüsseldienst und übernimmt entstandene Kosten bis max. 500 Euro.',
        },
        form: {
          title:
            'Einfach das Formular abschicken und du erhältst unmittelbar eine Bestätigungsemail mit Kontaktdaten zur Mietrechtsberatung:',
          footerText:
            'Ich stimme zu, dass meine Daten an die <a href="https://www.axapartners.de/" target="_blank" rel="noreferrer"> AXA Assistance </a> übermittelt und dort verarbeitet und zur Leistungserbringung genutzt werden. Ich stimme ferner zu, dass soweit dies der ordnungsgemäßen Durchführung der Versicherungsangelegenheit dient, die die AXA Assistance allgemeine Vertrags-, Abrechnungs- und Leistungsdaten in gemeinsame Datensammlungen der Versicherungsgruppe zusammenführt. Weitere Informationen zum Umgang mit Ihren Daten finden Sie <a href=https://www.axapartners.de/datenschutz" target="_blank" rel="noreferrer"> hier </a>.',
          cancelButtonText: 'Abbrechen',
          submitButtonText: 'Jetzt aktivieren',
          saveButtonText: 'Speichern',
          backButtonText: 'Zurück',
          city: {
            label: 'Ort',
            placeholder: '',
          },
          salutation: {
            label: 'Anrede',
            options: {
              female: 'Frau',
              male: 'Herr',
            },
          },
          firstName: {
            label: 'Vorname',
            placeholder: '',
          },
          lastName: {
            label: 'Nachname',
            placeholder: '',
          },
          street: {
            label: 'Straße',
            placeholder: '',
          },
          houseNumber: {
            label: 'Hausnr.',
            placeholder: '',
          },
          postcode: {
            label: 'PLZ',
            placeholder: '',
          },
        },
        linkButton: 'Wohnen+ entdecken',
        activeButton: 'Schlüsselnotdienst aktivieren',
      },
    },
    billCheckV3: {
      headline: 'Nebenkosten-Check',
      multiStepFlow: {
        progressBar: {
          step: 'Schritt',
        },
        balanceDetailsStep: {
          title: 'Details zu deiner aktuellen Nebenkostenabrechnung',
          form: {
            balanceType: 'Dein Ergebnis',
            balanceAmount: 'Höhe des Betrags',
            balanceAmountPlaceholder: 'z.B. 1.500',
            radioGroup: {
              additionalPayment: 'Nachzahlung',
              credit: 'Gutschrift',
            },
            errorMessages: {
              negativeBalanceAmount: 'Der Betrag muss 0 oder größer sein',
            },
          },
        },
        accountingPeriodDetailsStep: {
          title: 'Zeitliche Angaben zu deiner Nebenkostenabrechnung',
          form: {
            accountingPeriodDates: 'Abrechnungszeitraum',
            deliveryDate: 'Erhalt der Abrechnung',
            deliveryDatePlaceholder: 'z.B. 16.06.2025',
            validation: {
              futureDateError: 'Zustellungsdatum der Abrechnung kann nicht in der Zukunft liegen',
              invalidStartDateError: 'Das Startdatum des Abrechnungszeitraums kann nicht in der Zukunft liegen',
              invalidEndDateError:
                'Das Startdatum des Abrechnungszeitraums darf nicht nach dem Enddatum des Abrechnungszeitraums liegen',
            },
          },
        },
        customerDetailsStep: {
          title: 'Persönliche Angaben',
          form: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            gender: 'Anrede',
            selectPlaceholder: '-Bitte wählen-',
          },
        },
        rentalContractUploadStep: {
          title: 'Mietvertrag hochladen',
          subtitle: 'Bitte lade alle Seiten und Anhänge hoch',
          submitCta: 'Abschließen und senden',
        },
        operationalStatementUploadStep: {
          title: 'Nebenkostenabrechnung hochladen',
          subtitle: 'Bitte lade alle Seiten und Anhänge hoch',
        },
        common: {
          mandatoryField: '*Pflichtfeld',
          uploadTitle: 'Dokument hier hinzufügen',
          rentalContractUploadSubtitle: 'Mietvertrag',
          utilityBillcheckUploadSubtitle: 'Nebenkostenabrechnung',
        },
        fileInput: {
          fileSelectionConditionsDesktop: 'PDF/ JPEG/ PNG bis 25 MB hier ablegen',
          fileSelectionConditions: 'PDF/ JPG/ PNG bis 25 MB',
          documentSelectionCtaDesktop: 'Oder Dokumente auswählen',
          documentSelectionCta: 'Dokumente auswählen',
          errorMessages: {
            exceedingFileSize: 'Die Größe des Dokuments darf 25 MB nicht überschreiten',
            unsupportedFileTypeSelection: 'Nur PDF, PNG oder JPEG Dateien sind erlaubt',
            exceededMaxNumberOfAllowedFiles: 'Es können maximal {maxNumberOfFiles} Dateien ausgewählt werden.',
          },
          infoLabel: {
            maxNumberOfFilesReached: 'Die maximale Anzahl an erlaubten Dateien wurde erreicht.',
          },
        },
        loadingState: {
          dataBeingSubmitted: 'Daten werden übermittelt',
          fileUploadProgress: 'Dateien hochgeladen',
        },
        errorState: {
          serviceUnavailable: {
            message: 'Das hat leider nicht geklappt! Bitte versuche es zu einem späteren Zeitpunkt noch einmal.',
            ctaLabel: 'Zurück zum Plus-Bereich',
          },
          tryAgain: {
            message: 'Das hat leider nicht geklappt! Bitte starte die Eingabe noch einmal.',
            ctaLabel: 'Eingabe nochmal starten',
          },
        },
      },
      modal: {
        buttonCta: {
          startBillcheck: 'Nebenkosten-Check starten',
          continueBillCheck: 'Nebenkosten-Check fortsetzen',
          startCheck: 'Check starten',
        },
        image: 'Papier, Bleistift und Taschenrechner',
        faq: {},
        overview: {
          discoverWohnenPlusCta: 'Wohnen+ entdecken',
          billCheckNotification: {
            headline: 'Fehlende Angaben',
            description1: 'Bitte vervollständige noch die letzten Angaben.',
            description2: 'Auftrag fortsetzen',
          },
          billCheckList: {
            title: 'Meine Prüfungsanträge',
            orderNumberColumnLabel: 'Aufragsnr.',
            dateColumnLabel: 'Datum',
            startNewOrderCta: 'Neuen Auftrag starten',
            description:
              'Als Wohnen+ Mitglied kannst du einmal im Jahr kostenlos einen Nebenkosten-Check durchführen. Am <b>{nextCheckDate}</b> kannst du deine Nebenkosten erneut prüfen.',
          },
          statusBox: {
            done: {
              headline: 'Die Prüfung deiner Unterlagen wurde abgeschlossen',
              description: 'Wir haben dir das Ergebnis der Prüfung per E-Mail zugesendet.',
            },
            submitted: {
              headline: 'Die Prüfung deiner Unterlagen hat begonnen',
              description: 'Innerhalb von 5 Werktagen erhältst du das Ergebnis per E-Mail.',
            },
            ordered: {
              headline: 'Sie haben eine unvollständige Prüfung.',
              description: 'Bitte setze deine Registrierung auf der Mineko-Website fort, um den Vorgang abzuschließen.',
            },
            ctaLabel: 'Fahren Sie mit der Registrierung fort',
            ticketNumberInfo: '<b>Deine Auftragsnummer: </b>{minekoTicketId}',
            ticketNumberInfoLabel: '<b>Deine Auftragsnummer: </b> ',
          },
          footer: {
            customerService: 'Kundenservice',
            paragraph: 'Falls du Fragen hast stehen wir dir gerne zur Verfügung:',
            phoneNumber: '+49 30 40365750',
            operatingHours: 'Mo - Fr 9:00 - 18:00 Uhr',
            contactEmail: 'kontakt@mineko.de',
          },
          title: 'Geld von Vermieter:innen zurück mit dem Nebenkosten Schnell-Check',
          paragraph1:
            'Viele Nebenkostenabrechnungen sind zu hoch. Lass deine Abrechnung durch die Rechtsexpert:innen von Mineko prüfen und erhalte bei Fehlern Geld von deinem:deiner Vermieter:in zurück.',
          checklist: {
            item1: 'Bequem von Zuhause als Scan oder Foto hochladen',
            item2: 'Persönliches Prüfergebnis innerhalb von 5 Tagen von Expert:innen erhalten',
            item3: 'Einmal im Jahr in {LivingPlusLogo} enthalten',
          },
        },
        howItWorks: {
          image1: 'Oben im Posteingang',
          image2: 'Geöffnete Post',
          image3: 'Euro-Symbol',
          description1: 'Bequem von Zuhause Mietvertrag und Nebenkostenabrechnung als Foto oder Scan hochladen.',
          description2:
            'Innerhalb von 5 Tagen ausführlichen Prüfbericht und personalisiertes Widerspruchsschreiben erhalten und an Vermieter:innen weiterleiten.',
          description3:
            'Vermieter:innen erstellen eine neue, korrekte Abrechnung und zahlen bereits zu viel gezahltes Geld zurück.',
        },
      },
    },
    tenantProtectionServices: {
      headline: 'MieterEngel Mieterschutz',
      modal: {
        image: 'MieterEngel Mieterschutz',
        overview: {
          paragraph: 'Mit MieterEngel bist du bei Mietproblemen abgesichert. Digital und modern.',
          var1: 'In Suchen+ für Miete und Wohnen+ enthalten - ab dem ersten Tag.',
          var2: 'In Suchen+ für Miete enthalten (bei 6 & 12 Monate Mindestlaufzeit).',
          checkmark: {
            title: 'Mehr Sicherheit mit MieterEngel:',
            list: {
              item1: {
                title: 'Lass deinen Mietvertrag prüfen:',
                text: 'Recht bekommt, wer seine Rechte kennt. Aber kennst du jedes Detail in deinem Mietvertrag?',
              },
              item2: {
                title: 'Hol dir dein Geld zurück:',
                text: "Steigende Preise lassen die Nebenkosten in die Höhe schießen. Wusstest du aber, dass jede 2. Nebenkostenabrechnung Fehler enthält und sich im Schnitt 250 € bei Überprüfung sparen lassen? Wie sieht's mit deiner aus?",
              },
              item3: {
                title: 'Geh Probleme früh an:',
                text: 'Beim Einzug sah noch alles gut aus, aber nach dem ersten Regen ein Wasserfleck, was nun?',
              },
              item4: {
                title: 'Werde bei drohenden Konflikten beraten:',
                text: 'Recht bekommt, wer seine Rechte kennt. Aber kennst du jedes Detail in deinem Mietvertrag?',
              },
              item5: {
                title: 'Lass deinen Mietvertrag prüfen:',
                text: 'Was tun bei ungültigen Absätzen im Vertrag oder nicht nachvollziehbaren Vermieterschreiben?',
              },
            },
          },
          bulletList: {
            title: 'Deine Rechtsberatung von Partneranwälten:innen',
            item1: 'Zu allen Mietproblemen',
            item2: 'Telefonisch & schriftlich',
            item3: 'Antwort in der Regel in 48h',
            item4: '1x jährliche Nebenkostenprüfung',
            item5: 'Feste Ansprechperson über das ganze Jahr',
          },
          footerSection: {
            title: 'Weitere MieterEngel Vorteile:',
            list: {
              item1: 'Online Kundenkonto & Betreuung durch MieterEngel Team',
              item2: 'Mietrecht einfach & verständlich: 200+ Ratgeber, Checklisten und Muster',
              item3: 'Vorlagen & Editor für deine Kommunikation mit Vermieter:innen oder der Hausverwaltung',
            },
          },
        },
        howItWorks: {
          image1: 'Papier und Stift',
          image2: 'Geöffneter Briefumschlag',
          image3: 'Download-Symbol',
          image4: 'Münze',
          title1: 'Aktiviere MieterEngel',
          title2: 'Stelle deine Frage',
          title3: 'Rechtsberatung von Partneranwält:innen',
          paragraph1:
            'Ab dem ersten Tag Zugang zu MieterEngel erhalten. Mit der Anmeldung im Portal bekommst du einen persönlichen Anwalt oder Anwältin zugeteilt. Du kannst entscheiden, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll.',
          paragraph2:
            'Dein Mietproblem – deine individuelle Beratung. Dafür werden je nach Fall verschiedene Dokumente benötigt. Wir lassen dich wissen, welche Dokumente zu deinem Mietproblem hochzuladen sind (z.B. Mietvertrag, Nebenkostenrechnung, Schreiben vom Vermieter, etc.). Das geht direkt über den Browser oder über das Smartphone. Achte darauf, dass Fotos und Scans gut lesbar sind!',
          paragraph3:
            'Schriftlich oder per Telefon. Egal wie voll dein Terminkalender oder wie lang deine To-do-List ist. Individueller Mieterschutz direkt auf dich zugeschnitten. Du entscheidest, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll. Sobald alle Unterlagen hochgeladen sind, erhältst du innerhalb von wenigen Tagen eine Antwort. Solltest du lieber telefonisch mit dem Partneranwalt oder der Partneranwältin sprechen wollen, erhältst du einen minutengenauen Termin, den du ganz bequem einplanen kannst.',
        },
        faq: {
          item0: {
            question: 'Was ist MieterEngel?',
            answer:
              'MieterEngel bietet deutschlandweiten Mieterschutz. Egal, ob Großstadt oder kleine Gemeinde, MieterEngel kümmert sich um dich als Mieter:in. Du erhältst über unsere WebApp außergerichtlichen Rechtsbeistand zu allen Mietproblemen von ausgewählten Partner:innen. Stelle jederzeit deine Fragen und erhalte in der Regel in 48 Stunden eine schriftliche Antwort oder einen minutengenauen Telefontermin.',
          },
          item1: {
            question: 'Wer berät mich?',
            answer:
              'Die Rechtsberatung findet durch ausgewählte Partneranwältinnen und Partneranwälten statt, die durch MieterEngel mit besonderer Sorgfalt ausgewählt werden. Voraussetzung ist, dass sie mindestens 5 Jahre Praxiserfahrung im Mietrecht haben. Dazu haben 85% einen Doktortitel und 80% sind Fachhanwälte bzw. Fachanwältinnen für Mietrecht. Neben der fachlichen, legen wir besonderen Wert auf die persönliche Kompetenz. Unsere Partner:innen wissen wie Konflikte schnell gelöst werden.',
          },
        },
        customerService: {
          headline: 'Weitere Fragen?',
          text: 'Falls du Fragen hast steht der Kundenservice dir gerne zur Verfügung:',
          phoneNumber: '030 5557 1887',
          businessHours: 'Mo bis Fr, 8 - 18.30 Uhr',
          businessHoursWeekend: 'Sa, 11 - 15 Uhr',
        },
        buttonBasic: 'Wohnen+ entdecken',
        buttonPlus: 'Zum MieterEngel Portal',
      },
    },
    storageService: {
      headline: 'Lagerraum',
      modal: {
        headline: 'Lagerraum',
        image: 'Lagerraum',
        overview: {
          paragraph1: 'Zusätzlichen Platz mieten mit einem Lagerraum von LAGERBOX.',
          bullet1IsEntitled: 'Schon ab 1m³ / 1 Woche / 9,95 €',
          bullet1: 'Schon ab 9,95 € mtl.',
          bullet2: 'Deutschlandweit',
          bullet3: 'Exklusiver Rabatt mit',
          subBullet1: '5 % Rabatt auf Basic Paket',
          subBullet2: '15 % Rabatt auf Premium Paket',
          WohnenPlusLink: 'Wohnen+ entdecken',
          request: {
            title: 'Anfrage gesendet',
            description:
              'Deine Anfrage wurde erfolgreich gesendet.  LAGERBOX wird sich innerhalb der nächsten 48h bei dir telefonisch melden. Solltest du noch weitere Fragen haben, melde dich beim Kundenservice von Lagerbox ',
            customerService: {
              headline: 'Noch Fragen?',
              text: 'Der LAGERBOX-Kundenservice hilft dir gerne persönlich weiter',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mo - Fr 8-21 Uhr',
              businessHoursWeekend: 'Sa 9-17 Uhr',
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Papier und Stift',
          image2: 'Geöffneter Briefumschlag',
          image3: 'Lagerraum-Symbol',
          image4: 'Münze',
          paragraph1: 'Antragsformular in nur wenigen Minuten ausfüllen und absenden.',
          paragraph2: 'Angebot von Lagerbox innerhalb von 48h erhalten.',
          paragraph3: 'Lagerraum von LAGERBOX mieten.',
        },
        faq: {
          item0: {
            question: 'Was ist Selfstorage?',
            answer:
              'Selfstorage ist Englisch und bedeutet so viel wie "selbst lagern". Bei LAGERBOX mietest du vereinfacht gesprochen, einen zusätzlichen Raum für mehr Platz an – und zwar so lange und so groß, wie Sie möchten.',
          },
          item1: {
            question: 'Bieten Sie Umzugshilfe/Hilfe beim Transport an?',
            answer:
              'Wir stellen die freien Lagerräume, jedoch nicht die Lagerlogistik zur Verfügung. Das bedeutet für dich, dass du als Kunde für die Ein- und Auslagerung von Gütern in deinem Lagerraum selbst verantwortlich bist. Trotzdem und selbstverständlich ist es natürlich möglich, sich durch Dienstleister, zum Beispiel Umzugsunternehmen, oder aber auch Freunde und Bekannte beim Befüllen der Lagereinheit helfen zu lassen.',
          },
          item2: {
            question: 'Wer hat außer mir noch Zugang zu meinem Lagerraum?',
            answer:
              'Bei LAGERBOX wird Sicherheit großgeschrieben. Daher haben nur du allein Zugang zu deinem persönlichen Lagerraum. Du kannst auf Wunsch allerdings weitere Personen zum Zugang berechtigen. Das funktioniert, indem du im Mietvertrag weitere zugangsberechtigte Personen angeben oder diese kurzfristig durch eine entsprechende Vollmacht festlegst. Diese zutrittsberechtigten Personen haben dann ebenfalls und wie du uneingeschränkten Zugriff auf den Lagerraum. Wichtig ist natürlich, dass sofern weitere Personen zum Zutritt berechtigt sein sollen, diese auch einen Schlüssel für den Lagerraum besitzen müssen. Du musst außerdem gegenüber unserem Personal auf Nachfrage durch einen amtlichen Lichtbildausweis ausweisen können.',
          },
          item3: {
            question: 'Sind die Lagerräume abschließbar?',
            answer:
              'Die Räume bei LAGERBOX sind einzeln abschließbar und werden durch ein Vorhängeschloss gesichert, das du im Umzugsshop vor Ort günstig kaufen oder wahlweise auch einfach selbst aus dem eigenen Bestand mitbringen kannst.',
          },
          item4: {
            question: 'Was sollte ich bei der Einlagerung beachten?',
            answer:
              'Ein wichtiger Tipp unsererseits betrifft deine Lagerfläche: Nutze den Raum ökonomisch. Wenn du zum Beispiel für längere Zeit Möbel einlagerst, ist es sicherlich zielführend, diese auseinanderzubauen. Bei der Einlagerung von Stoffen, Textilien und Teppichen empfehlen wir dringend, diese durch Mottenschutzmittel vor Schädlingsbefall zu schützen. LAGERBOX führt zwar in regelmäßigen Abständen vorbeugende Maßnahmen zur Schädlingsbekämpfung in den Lagerhallen durch, dennoch können wir einen Schädlingsbefall nie ganz ausschließen. Weiterhin solltest du darauf achten, dass die Textilien trocken sind. Bei der Verpackung ist darauf zu achten, dass die Textilien nicht luftdicht abgeschlossen sind. Beachte bei der Einlagerung deiner Gegenstände die maximal nutzbare Lagerraumhöhe. Diese kannst du deinem Mietvertrag entnehmen oder auch bei unserem Personal vor Ort erfragen.',
          },
          item5: {
            question: 'Wie hoch sind die Lagerräume?',
            answer:
              'In der Regel sind unsere Boxen drei Meter hoch. Die Einhaltung der maximalen Lagerraumhöhe ist von großer Bedeutung, denn sie gewährleistet die einwandfreie Funktion unserer Brandschutzeinrichtungen und ist daher von besonderem Interesse für alle Kunden unserer Selfstorage-Häuser. Bei weiterem Informationsbedarf zu diesem Thema rufe am besten am entsprechenden LAGERBOX-Standort an und lasse dich von unseren Mitarbeitern informieren.',
          },
          item6: {
            question: 'Bietet LAGERBOX einen Paketannahme-Service an?',
            answer:
              'Ja, wir nehmen gerne Pakete für unsere Kunden an. Aber nicht in großen Mengen und nicht jeden Tag. Größere bzw. regelmäßige Warenlieferungen müssen durch eine Spedition eingelagert werden oder vom Kunden (bzw. einem von Ihnen Bevollmächtigten) in Empfang genommen werden.',
          },
          item7: {
            question: 'Sind die LAGERBOX-Hallen alarm- und videoüberwacht?',
            answer:
              'Ja, die LAGERBOX-Hallen sind video- und alarmüberwacht. Du genießt also eine zuverlässige 24-stündige Überwachung, wenn du bei uns einlagerst.',
          },
          item8: {
            question: 'Bietet ihr beim Einzug einen kostenlosen Transporter an?',
            answer:
              'Ja, der Gratis-Transporter ist eines unserer beliebtesten Komfort-Extras für Kunden! Du erhältst das Fahrzeug oder einen Anhänger gratis beim Einzug/am Einzugstag nach Terminabsprache und bei Auszug. Die Nutzung beinhaltet für den Transporter 30 Inklusivkilometer und erstreckt sich über den Büroarbeitstag der jeweiligen Filiale. Unsere Mitarbeiter erklären dir gerne die genauen Bedingungen für die Nutzung.',
          },
          item9: {
            question: 'Gibt es kostenlose Transporthilfen wie Sackkarren, Hub- und Rollwagen?',
            answer:
              'Ja, wir haben an allen Standorten kostenlose Transporthilfen wie Sackkarren, Hub- und Rollwagen. Diese stehen unseren Kunden an allen LAGERBOX-Standorten zur freien und kostenlosen Verfügung.',
          },
          item10: {
            question: 'Wie lang ist die Kündigungsfrist?',
            answer:
              'Die Kündigungsfrist bemisst sich an der Vertragslaufzeit: Monatsverträge haben eine Kündigungsfrist von einem Tag.',
          },
          item11: {
            question: 'Was ist, wenn ich meine Lagerbox länger brauche als geplant. Ist sie dann noch frei?',
            answer:
              'Ja, deine Lagerbox ist auch nach Ablauf des Mietvertrags noch frei, sodass du deine Mietdauer verlängern kannst.',
          },
          item12: {
            question: 'Was passiert, wenn ich nach Vertragsabschluss mehr oder weniger Platz brauche?',
            answer:
              'Wir sind flexibel. Die Verkleinerung der Boxengröße ist nach dem ersten Monat möglich. Eine Vergrößerung der Lagerbox ist in der Regel sofort durchführbar. Beides unter der Voraussetzung, dass die Verfügbarkeit des gewünschten Lagerraums gegeben ist. Bespreche dies am besten direkt mit dem LAGERBOX-Team am Standort.',
          },
          item13: {
            question: 'Haben die LAGERBOX-Häuser überdachte Ladebereiche?',
            answer:
              'Ja, alle unsere Standorte haben überdachte Ladebereiche. Diese Drive-in-Areas sind Teil unseres besonderen Komfort-Versprechens. Sie sorgen dafür, dass du auch bei Wind und Wetter im Trockenen ein- und ausladen und damit schließlich auch dein Lagergut trocken und unversehrt bleibt.',
          },
        },
        form: {
          footerText:
            'Ihre Daten werden zum Zwecke der Kontaktaufnahme und Beratung (E-Mail oder Telefon) an die Lagerbox Holding GmbH, Hauptverwaltung Hanauer Landstraße 314, 60314 Frankfurt am Main ("Lagerbox") weitergeleitet.',
          backButtonText: 'Zurück',
          submitButtonText: 'Anfrage absenden',
          city: {
            label: 'Gewünschter Ort *',
            placeholder: '- Standort auswählen -',
          },
          salutation: {
            label: 'Anrede',
            options: {
              female: 'Frau',
              male: 'Herr',
            },
          },
          firstName: {
            label: 'Vorname *',
            placeholder: '',
          },
          lastName: {
            label: 'Nachname *',
            placeholder: '',
          },
          email: {
            label: 'E-Mail *',
            placeholder: '',
          },
          phoneNumber: {
            label: 'Telefonnummer *',
            placeholder: '',
          },
          description: {
            label: 'Nachricht',
            placeholder: 'Schreibe eine Nachricht....',
          },
        },
        linkButton: 'Mit 5 % Rabatt fortfahren',
        isEntitledLinkButton: 'Unverbindliches Angebot anfordern',
      },
    },
    rentLegal: {
      headline: 'Mietrechtsberatung',
      modal: {
        faq: {},
        headline: 'Mietrechtsberatung',
        image: 'Neubau im Sonnenschein',
        overview: {
          paragraph1: 'Unterstützung bei Rechtsfragen durch die Mietrechtsberatung der AXA Assistance',
          paragraph2:
            'Ob überhöhte Mietforderungen oder Lärmbelästigung durch die Nachbarschaft? Mit der Mietrechtsberatung der AXA Assistance erhältst du eine telefonische Erstberatung zu deinen Rechtsfragen.',
          bullet1: 'Beratung von geprüften Anwälten der AXA Assistance',
          bullet2: 'Telefonische Erstberatung für bis zu drei Mietrechtsfragen im Jahr',
          bullet3: 'In {BuyerPlusLogo} enthalten',
          request: {
            keyEmergencyService: {
              title: 'Aktivierung erfolgreich',
              text: 'Der Mietrechtsberatung wurde erfolgreich aktiviert.',
              insuranceStatus: {
                title: 'Service aktiv',
                deaktivieren: '(deaktivieren)',
                kundennummer: 'Deine Kundennummer',
                versicherungsnummer: 'Versicherungsnummer',
                anschrift: 'Deine Anschrift',
                kontaktdaten: 'Kontaktdaten für den Notfall',
                dokumente: 'Dokumente',
                cancellationText: 'Bist du sicher, dass du die Mietrechtsberatung deaktivieren möchtest?',
                cancellationButton: 'Deaktivieren',
                cancellationButtonCancel: 'Abbrechen',
                edit: 'ändern',
                customerService: {
                  phoneNumber: '0221 80247 1360',
                  phoneNumberText: ' Täglich rund um die Uhr erreichbar',
                  email: 'immobilienscout24@axa-assistance.de',
                },
              },
              axaFooter: {
                title: 'Du hast deinen Schlüssel verloren und benötigst Hilfe?',
                text: 'Mit dem Mietrechtsberatung der AXA werden Kosten bis max. EUR 500,- übernommen.',
                companyName: 'Inter Partner Assistance Service GmbH',
                companyStreet: 'Große Scharmstraße 36',
                companyCity: '15230 Frankfurt (Oder)',
              },
            },
            title: 'Aktivierung erforderlich',
            description:
              'Du musst die Mietrechtsberatung vorab kostenlos abschließen, damit du im Notfall abgesichert bist',
            description2: 'Die Mietrechtsberatung wurde erfolgreich aktiviert.',
            customerService: {
              headline: 'Noch Fragen?',
              text: 'Der LAGERBOX-Kundenservice hilft dir gerne persönlich weiter',
              phoneNumber: '0800 / 222 666 999',
              businessHours: 'Mo - Fr 8-21 Uhr',
              businessHoursWeekend: 'Sa 9-17 Uhr',
              email: 'immobilienscout@lagerbox.com',
            },
          },
        },
        howItWorks: {
          image1: 'Police',
          image2: 'Waage',
          image3: 'Telefonhörer',
          paragraph1: 'Mietrechtsberatung zuvor online in unter 2 Minuten aktivieren und Kontaktdaten erhalten.',
          paragraph2:
            'Bei Rechtsproblem und Rechtsfragen in Zusammenhang mit Miet- und Immobilienrecht die AXA Assistance via Telefon oder E-Mail kontaktieren.',
          paragraph3: 'Eine telefonische Erstberatung erhalten und eine rechtlich fundierte Meinung einholen.',
        },
        form: {
          title:
            'Einfach das Formular abschicken und du erhältst unmittelbar eine Bestätigungsemail mit Kontaktdaten zur Mietrechtsberatung:',
          footerText:
            'Ich stimme zu, dass meine Daten an die <a href="https://www.axapartners.de/" target="_blank" rel="noreferrer"> AXA Assistance </a> übermittelt und dort verarbeitet und zur Leistungserbringung genutzt werden. Ich stimme ferner zu, dass soweit dies der ordnungsgemäßen Durchführung der Versicherungsangelegenheit dient, die die AXA Assistance allgemeine Vertrags-, Abrechnungs- und Leistungsdaten in gemeinsame Datensammlungen der Versicherungsgruppe zusammenführt. Weitere Informationen zum Umgang mit Ihren Daten finden Sie <a href=https://www.axapartners.de/datenschutz" target="_blank" rel="noreferrer"> hier </a>.',
          cancelButtonText: 'Abbrechen',
          submitButtonText: 'Jetzt aktivieren',
          saveButtonText: 'Speichern',
          backButtonText: 'Zurück',
          city: {
            label: 'Ort',
            placeholder: '',
          },
          salutation: {
            label: 'Anrede',
            options: {
              female: 'Frau',
              male: 'Herr',
            },
          },
          firstName: {
            label: 'Vorname',
            placeholder: '',
          },
          lastName: {
            label: 'Nachname',
            placeholder: '',
          },
          street: {
            label: 'Straße',
            placeholder: '',
          },
          houseNumber: {
            label: 'Hausnr.',
            placeholder: '',
          },
          postcode: {
            label: 'PLZ',
            placeholder: '',
          },
        },
        linkButton: 'Wohnen+ entdecken',
        activeButton: 'Mietrechtsberatung aktivieren',
      },
    },
    documents: {
      headlines: {
        profileAndDocuments: 'Profil & Dokumente',
        applicantFolder: 'Bewerbermappe',
      },
      modal: {
        faq: {},
      },
    },
    opportunityCheck: {
      headline: 'Chancen-Check',
      modal: {
        image: 'Handy mit Chancen-Check Vorschau',
        overview: {
          paragraph1: 'Gute Aussichten? Wir zeigen dir transparent deine Chancen.',
          paragraph2:
            'Wie viele Interessierte gibt es wirklich? Passt Dein Budget zum Objekt? Erfahre exklusiv und vorab, wie Deine Chancen auf Deine Wunschimmobilie stehen und spare wertvolle Zeit.',
        },
        howItWorks: {
          paragraph:
            'Mit dem Chancen-Check im Expose berechnen wir deine Chancen auf die Immobilienanzeige. Diese berechnet sich aus Nachfrage und Interessent:innenanalyse.',
          section1: {
            title: 'Anzeigennachfrage',
            paragraph:
              'Wir zeigen dir, wie lange die Anzeige bereits online ist, von wie vielen Personen sie bereits gesehen wurde und wie viele sich für das Objekt interessieren.',
            image: 'Anzeigennachfrage auf Mobiltelefon',
          },
          section2: {
            title: 'Interessent:innenanalyse',
            paragraph:
              'Wir geben dir Aufschluss über deine Konkurrenz, also Personen, welche sich das Objekt auf die Merkliste gesetzt oder es kontaktiert haben. Nutze den Wissensvorsprung beim Kontakt mit den Anbietenden!',
            image: 'Interessent:innenanalyse auf Mobiltelefon',
          },
        },
        faq: {
          item0: {
            question: 'Wie stehen die Ergebnisse im Zusammenhang mit meinen Chancen?',
            answer:
              'Der Chancen-Check gibt dir konkrete Zahlen dazu an die Hand, wie viele und welche Personen zu dem jeweiligen Objekt eine Kontaktanfrage gesendet haben. Tendenziell hast du bessere Chancen, wenn du unter den Ersten bist, die sich bei einem neu eingestellten Objekt melden.<br/><br/>Eigentümer:innen und Makler:innen erwarten zudem mit Plus-Mitgliedern eine höhere Realisierungswahrscheinlichkeit als mit Mitgliedern ohne Plus. Bei den Eigenschaften der Interessent:innen  kommt es, insbesondere für Eigentümer:innen, oft am meisten darauf an, wie gut diese zur Immobilie passen. Hier kannst du punkten: Sind Wohnfläche und Umfeld beispielsweise eher für einen Großstadtsingle oder eine junge Familie geeignet?',
          },
          item1: {
            question:
              'Lohnt es sich noch, eine Anzeige zu kontaktieren, welche bereits eine Vielzahl an Kontaktanfragen erhalten hat?',
            answer:
              'Das hängt sehr vom Einzelfall ab. Zwar steigt die Wahrscheinlichkeit mit zunehmender Zeit und Anzahl an Kontaktanfragen, dass ein Objekt erfolgreich verkauft wird, aber Kaufvorgänge können sehr lange dauern. Dabei gibt es viele Gründe, warum der Kauf doch nicht zustande kommt, z.B. weil die derzeitigen Eigentümer:innen ganz genaue Vorstellungen über die Käufer:innen haben. Lass dich also nicht von einer hohen Anzahl an Kontaktanfragen abschrecken.',
          },
          item2: {
            question: 'Woher stammen die aufgeführten Daten?',
            answer:
              'Die Statistiken beruhen auf den anonymisierten Angaben aller Kontaktanfragen zum jeweiligen Objekt, die über unser Portal eingegangen sind.',
          },
          item3: {
            question:
              'Bietet der Chancen-Check mir weiterhin einen Vorteil, wenn der Großteil der Nutzer:innen bereits Plus hat?',
            answer:
              'Der Chancen-Check hilft dir als Plus-Mitglied dabei deine Konkurrenz zu kennen und deine Chancen auf die Immobilie somit besser einzuschätzen. Suchen+ für Kauf Mitglieder stellen einen kleinen Teil der User:innen von ImmoScout24 dar, somit bleibt dir der Vorteil gegenüber der Mehrheit weiterhin erhalten.',
          },
        },
      },
    },
    opportunityCheckMieterPlus: {
      headline: 'Chancen-Check',
      modal: {
        image: 'Handy mit Chancen-Check Vorschau',
        overview: {
          paragraph1: 'Gute Aussichten? Wir zeigen dir transparent deine Chancen.',
          point1: 'Analyse der Nachfrage',
          point2: 'Dein Profil im Vergleich mit den Präferenzen der Vermieter:innen',
          point3: 'Informationen über deine Konkurrenz',
          linkButton: 'Suchen+ entdecken',
          activeMieterPlus: 'In {MieterPlusLogo} enthalten',
        },
        linkButton: 'Suchen+ entdecken',
        faq: {},
      },
    },
    exclusiveListings: {
      headline: 'Exklusive Anzeigen',
      modal: {
        image: 'Handy mit exklusive Anzeigen Vorschau',
        overview: {
          paragraph1:
            '"Exklusive Anzeigen" stammen von privaten Eigentümer:innen und können in den ersten 72 Stunden zuerst von dir als Plus-Mitglied kontaktiert werden. So bekommst du einen Vorsprung vor anderen.',
          paragraph2:
            'Die Exklusiven Anzeigen erscheinen für dich automatisch wie alle anderen Anzeigen bei der Suche bzw. in Benachrichtigungen. Sie sind nicht gesondert gekennzeichnet.',
          activeKaeuferPlus: 'In {BuyerPlusLogo} enthalten',
        },
        linkButton: 'Suchen+ entdecken',
        faq: {
          item0: {
            question: 'Wie hoch ist mein Vorteil, wenn meine Konkurrenz aus Plus-Nutzer:innen besteht?',
            answer:
              'Aus Gesprächen mit unseren Anbietenden wissen wir, dass die überwiegende Mehrheit bereits unter den ersten Anfragen passende Kandidat:innen auswählt.<br/><br/>Suchen+ für Kauf Mitglieder stellen einen kleinen Teil der User:innen von ImmoScout24 dar. Durch die Beschränkung auf Plus-Mitglieder während der ersten 72 Stunden ist somit bereits ein Vorteil gegenüber anderen Interessierten ohne Plus gegeben. Innerhalb der interessierten Personen mit Plus-Mitgliedschaft ist dann oft entscheidend, wie gut die Interessierten gemessen an den Vorstellungen der Verkäufer:innen (z.B. Preisvorstellungen, Erreichbarkeit, wahrgenommenes Interesse) zum Objekt passen.',
          },
          item1: {
            question: 'Welche Informationen sind für Nutzer:innen ohne Mitgliedschaft zugänglich?',
            answer:
              'Nutzer:innen ohne Plus-Mitgliedschaft können das Exposé inklusive aller für das Objekt verfügbaren Informationen wie Preis, Fläche, Zimmeranzahl und Bilder sehen. Sie haben jedoch innerhalb der ersten 72 Stunden keine Möglichkeit, die anbietende Person zu kontaktieren. Dies bleibt so lange Suchen+ für Kauf Mitgliedern vorbehalten.',
          },
          item2: {
            question: 'Sind Exklusive Anzeigen nur auf ImmoScout24 verfügbar?',
            answer:
              'Die überwiegende Mehrheit der Exklusiven Anzeigen finden sich nur auf ImmoScout24. Wir können nicht immer komplett ausschließen, dass Anbietende auch auf anderen Seiten inserieren, versuchen aber, entsprechend Anreize zu setzen.',
          },
          item3: {
            question: 'Wie viele Exklusive Anzeigen stehen für mich zur Verfügung?',
            answer:
              'Exklusive Anzeigen gibt es in ganz Deutschland. Das Angebot kann zeitlich sowie regional schwanken.',
          },
          item4: {
            question: 'Welchen Vorteil haben Anbietende von den Exklusiven Anzeigen?',
            answer:
              'Eine aufgeheizte Marktsituation in vielen Gebieten sorgt dafür, dass Anbietende viele Anfragen für ihre Objekte erhalten können. Eine Beschränkung auf Plus-Mitglieder innerhalb der ersten 72 Stunden kann helfen, den Anfragenstrom einzuschätzen, überschaubar zu halten und auf Suchende mit hoher Kaufwahrscheinlichkeit zu fokussieren.',
          },
          item5: {
            question: 'Wie unterscheiden sich die "Exklusiven Anzeigen" vom "Exklusiven Vorverkauf"?',
            answer:
              '"Exklusive Anzeigen" stammen von privaten Eigentümer:innen und sind die ersten 72 Stunden nur für Plus-Mitglieder kontaktierbar.<br/><br/>Anzeigen im "Exklusiven Vorverkauf" stammen von Makler:innen und sind die ersten 24 Stunden nur für Plus-Mitglieder kontaktierbar. Außerdem sind bei diesen Anzeigen weniger Details zum angebotenen Objekt sichtbar. ',
          },
        },
      },
    },
    exclusiveListingsMieterPlus: {
      headline: 'Exklusive Anzeigen',
      modal: {
        image: 'Handy mit exklusive Anzeigen Vorschau',
        overview: {
          paragraph1:
            '„Exklusive Anzeigen“ können in den ersten 72 Stunden zuerst von dir als Plus-Mitglied kontaktiert werden. So bekommst du einen Vorsprung vor anderen Mitbewerber:innen.',
          activeMieterPlus: 'In {MieterPlusLogo} enthalten',
        },
        linkButton: 'Suchen+ entdecken',
        faq: {
          item0: {
            question: 'Wie hoch ist mein Vorteil, wenn meine Konkurrenz aus Plus-Nutzer:innen besteht?',
            answer:
              'Aus Gesprächen mit unseren Anbietenden wissen wir, dass die überwiegende Mehrheit bereits unter den ersten Anfragen passende Kandidat:innen auswählt.<br/><br/>Suchen+ Miete Mitglieder stellen einen kleinen Teil der User:innen von ImmoScout24 dar. Durch die Beschränkung auf Plus-Mitglieder während der ersten 72 Stunden ist somit bereits ein Vorteil gegenüber anderen Interessierten ohne Suchen+ gegeben. Innerhalb der interessierten Personen mit Plus-Mitgliedschaft ist dann oft entscheidend, wie gut die Interessierten gemessen an den Vorstellungen der Verkäufer:innen (z.B. Preisvorstellungen, Erreichbarkeit, wahrgenommenes Interesse) zum Objekt passen.',
          },
          item1: {
            question: 'Welche Informationen sind für Nutzer:innen ohne Mitgliedschaft zugänglich?',
            answer:
              'Nutzer:innen ohne Plus-Mitgliedschaft können das Exposé inklusive aller für das Objekt verfügbaren Informationen wie Preis, Fläche, Zimmeranzahl und Bilder sehen. Sie haben jedoch innerhalb der ersten 72 Stunden keine Möglichkeit, die anbietende Person zu kontaktieren. Dies bleibt so lange Suchen+ Miete -Mitgliedern vorbehalten.',
          },
          item2: {
            question: 'Sind Exklusive Anzeigen nur auf ImmoScout24 verfügbar?',
            answer:
              'Die überwiegende Mehrheit der Exklusiven Anzeigen finden sich nur auf ImmoScout24. Wir können nicht immer komplett ausschließen, dass Anbietende auch auf anderen Seiten inserieren, versuchen aber, entsprechend Anreize zu setzen.',
          },
          item3: {
            question: 'Wie viel Exklusive Anzeigen stehen für mich zur Verfügung',
            answer:
              'Exklusive Anzeigen gibt es in ganz Deutschland. Das Angebot kann zeitlich sowie regional schwanken.',
          },
          item4: {
            question: 'Welche Vorteile haben Anbietende von den Exklsuiven Anzeigen?',
            answer:
              'Eine aufgeheizte Marktsituation in vielen Gebieten sorgt dafür, dass Anbietende viele Anfragen für ihre Objekte erhalten können. Eine Beschränkung auf Plus-Mitglieder innerhalb der ersten 72 Stunden kann helfen, den Anfragenstrom einzuschätzen, überschaubar zu halten und auf Suchende mit hoher Mietwahrscheinlichkeit zu fokussieren.',
          },
        },
      },
    },
    firstInInbox: {
      headline: 'Oben im Postfach',
      modal: {
        image: 'Smartphone Display zeigt Anbieterliste',
        overview:
          'Deine Nachrichten an die anbietende Person werden immer oben im Postfach von ImmoScout24 angezeigt und dein Profil erhält eine sichtbare Kennzeichnung als Plus-Mitglied.',
        faq: {
          item0: {
            question: 'Bietet die Einsortierung oben im Postfach der Anbietenden tatsächlich einen Vorteil für mich?',
            answer:
              'Aus Gesprächen mit unseren Anbietenden wissen wir, dass die überwiegende Mehrheit bereits unter den ersten Anfragen passende Kandidat:innen auswählt. Suchen+ Mitglieder stellen einen kleinen Teil der User:innen von ImmoScout24 dar. Durch die Beschränkung auf Plus-Mitglieder während der ersten 24 bis 72 Stunden ist somit bereits ein Vorteil gegenüber anderen Interessierten ohne Plus gegeben. Innerhalb der interessierten Plus-Mitglieder entscheidet dann oft die Vorstellung der Verkäufer:innen über die Kriterien (z.B Preisvorstellungen, Erreichbarkeit, wahrgenommenes Interesse) der zukünftigen Käufer:innen, ob diese zum Objekt passen. ',
          },
          item1: {
            question:
              'Wie wird meine Kontaktanfrage im Postfach der Anbietenden angezeigt im Verleich zu Nutzer:innen ohne Plus-Mitgliedschaft?',
            answer:
              'Anfragen von Plus-Mitgliedern erscheinen im Postfach der Anbietenden bei ImmoScout24 über denen der Nutzer:innen ohne Plus. Innerhalb der anfragenden Plus-Mitglieder werden die Anfragen nach Eingangszeit im Postfach sortiert mit den aktuellsten Nachrichten oben. Zudem werden Plus-Mitglieder mit einem Plus-Symbol gesondert als solche gekennzeichnet.',
          },
          item2: {
            question:
              'Warum würden Anbietende Plus-Mitglieder gegenüber Nutzer:innen ohne Plus-Mitgliedschaft bevorzugen?',
            answer:
              'Unsere Nutzer:innen besuchen ImmoScout24 in unterschiedlichen Lebenssituationen und mit unterschiedlichen Motivationen. Einige möchten erst ein Gefühl für den Markt oder wie sie leben möchten bekommen, wie Besichtigungen ablaufen oder sind sich unschlüssig, ob sie überhaupt kaufen möchten. Dies ist unter Suchen+ für Kauf Mitgliedern tendenziell seltener der Fall. Aus Makler:innensicht zeichnen sich diese mit höherer Wahrscheinlichkeit durch ein hohes Interesse und eine höhere Realisierungswahrscheinlichkeit aus, was ihnen Zeit und Aufwände ersparen kann.',
          },
        },
      },
    },
    firstInInboxMieterPlus: {
      headline: 'Oben im Postfach',
      modal: {
        image: 'Smartphone Display zeigt Anbieterliste',
        overview:
          'Deine Nachrichten an Anbieter:innen werden immer oben im Postfach von ImmoScout24 angezeigt und dein Profil erhält eine sichtbare Kennzeichnung als Plus-Mitglied.',
        linkButton: 'Suchen+ entdecken',
        activeMieterPlus: 'In {MieterPlusLogo} enthalten',
        faq: {},
      },
    },
    schufaCheck: {
      headline: 'SCHUFA-BonitätsCheck',
      modal: {
        image: 'Hände übergeben SCHUFA-BonitätsCheck Dokument',
        overview: {
          paragraph:
            'Original SCHUFA-BonitätsCheck, der von Plus-Mitgliedern einmal im Monat aktualisiert werden kann.',
          bullet1: 'Sofort online downloaden – auch von unterwegs',
          bullet2: 'Einmal bestellen und gleich an mehrere Anbieter:innen schicken',
          bullet3: 'Erhöhe die Chance auf dein Traumzuhause',
          bullet4: 'Monatliche Aktualisierung in {BuyerPlusLogo} enthalten',
        },
        howItWorks: {
          image1: 'Papier und Stift',
          image2: 'Geöffneter Briefumschlag',
          image3: 'Download-Symbol',
          image4: 'Münze',
          paragraph1: 'Name, Anschrift und Geburtsdatum im Online-Formular angeben.',
          paragraph2: 'Dokument innerhalb von 3-5 Werktagen per Post erhalten.',
          paragraph3:
            '…oder einfach direkt herunterladen durch Online-Verifizierung via Ausweisdokument oder Online-Banking.',
          paragraph4: 'Monatliche Aktualisierung des Original SCHUFA-BonitätsCheck in {BuyerPlusLogo} enthalten.',
        },
        deletionPeriod: {
          entryType: 'Art des Eintrags',
          deletionPeriod: 'Löschfrist',
          wrongEntries: 'Falsche Einträge',
          deletedImmediately: 'Umgehende Löschung',
          loans: 'Kredite',
          threeYearsAfterRepayment: 'Drei Jahre nach Rückzahlung',
          debtCollection: 'Inkasso-/Mahnverfahren',
          threeYearsAfterCompletion: 'Drei Jahre nach Abschluss',
          affidavit: 'Eidesstaatliche Versicherung',
          threeYearsAfterExpiry: 'Drei Jahre nach Ablauf',
          bankruptcyProceedings: 'Insolvenzverfahren',
          tenYearsUntilCompletion: 'Zehn Jahre bis zum vollständigen Abschluss',
        },
        faqHeadline1: 'SCHUFA-BonitätsCheck',
        faqHeadline2: 'Allgemeine Fragen',
        faq: {
          item0: {
            question: 'Was bietet der SCHUFA-BonitätsCheck?',
            answer:
              'Der BonitätsCheck ist die offizielle Bonitätsauskunft der SCHUFA (Kooperation mit der SCHUFA). Mit dem Verifizierungscode kann die Echtheit des Dokumentes überprüft werden. Hiermit kannst du deine grundsätzliche Zahlungsfähigkeit nachweisen. Die SCHUFA-Auskunft wird daher von vielen Anbietenden erwünscht.',
          },
          item1: {
            question: 'Wie sicher ist der SCHUFA-Bonitätscheck?',
            answer:
              'Deine Angaben werden nur zur Erstellung der Auskunft genutzt. Die Übertragung der Daten erfolgt sicher über SSL-Verschlüsselung.',
          },
          item2: {
            question: 'Was passiert mit meinen Daten?',
            answer:
              'Deine Angaben werden nur zur Erstellung der Auskunft genutzt. Die Übertragung der Daten erfolgt sicher über SSL-Verschlüsselung.',
          },
          item3: {
            question: 'Wie erhalte ich den SCHUFA-BonitätsCheck?',
            answer:
              'Die Erstellungszeit beträgt in der Regel nur wenige Sekunden. Du erhälst Deinen BonitätsCheck normalerweise direkt nach Deiner Bestellung als Online-Download oder auf dem Postweg.',
          },
          item4: {
            question: 'Wie lange dauert der Online-Versand des SCHUFA-BonitätsChecks?',
            answer:
              'Du erhältst den SCHUFA-BonitätsCheck direkt nach deiner Bestellung als Online-Download oder auf dem Postweg. Die Erstellungszeit beträgt in der Regel nur wenige Sekunden, wenn du die Versandart „Online-PDF“ gewählt hast und das Verifizierungsverfahren (finAPI - Online-Banking oder WebID – Personalausweis oder Reisepass) erfolgreich durchgeführt wurde.',
          },
          item5: {
            question: 'Wie lange dauert die SCHUFA-Auskunft per Post?',
            answer:
              'Bei der Versandart „Briefpost“ erhältst du das Dokument in aller Regel 1 bis 3 Tage nach der Bestellung.',
          },
          item6: {
            question: 'Kann ich den SCHUFA-BonitätsCheck auch mit einem ausländischen Ausweisdokument kaufen?',
            answer:
              'Der Onlinedownload des SCHUFA-BonitätsChecks und die damit verbundene Identifikation ist nur mit einem Online-Banking-Konto möglich. Solltest du dich für den Postversand deines SCHUFA-BonitätsChecks entscheiden, musst du über eine Meldeadresse in Deutschland verfügen. Ein Postversand ins Ausland ist leider nicht möglich.',
          },
          item7: {
            question: 'Was soll ich tun, wenn die Identitätsprüfung fehlschlägt?',
            answer:
              'Falls deine Identität nicht zweifelsfrei festgestellt werden konnte, bitten wir dich, auf den Postversand auszuweichen. Bitte hab Verständnis dafür, dass der Schutz deiner persönlichen Daten Vorrang hat.',
          },
          item8: {
            question: 'Wie kann der:die Anbieter:in die Richtigkeit der Daten im SCHUFA-BonitätsCheck überprüfen?',
            answer:
              'Der:die Anbieter:in kann die Daten mithilfe eines sogenannten Verifizierungscodes überprüfen. Der Verifizierungscode ist auf jedem SCHUFA-BonitätsCheck abgedruckt. Mittels dieses Codes kann überprüft werden, ob das entsprechende Ergebnisdokument zu einem validen SCHUFA-BonitätsCheck gehört.',
          },
          item9: {
            question: 'Was ist die SCHUFA?',
            answer:
              'Die Abkürzung SCHUFA steht für „Schutzgemeinschaft für allgemeine Kreditsicherung“. Die grundsätzlichen Aufgaben und Prinzipien der SCHUFA haben sich seit der Gründung 1927 nicht verändert: Das Ziel ist nach wie vor der Schutz der kreditgebender Institute vor Kreditausfällen – sowie der Schutz der Kreditnehmenden vor Überschuldung. Dies geschieht durch eine Vernetzung unterschiedlichster Vertragspartner:innen, die Informationen über dein Zahlungsverhalten an die SCHUFA weitergeben.',
          },
          item10: {
            question: 'Wofür brauche ich die SCHUFA?',
            answer: 'Mit dem SCHUFA-BonitätsCheck zeigst du dem:der Anbieter:in deine Zahlungsfähigkeit.',
          },
          item11: {
            question: 'Was steht in der SCHUFA-Auskunft?',
            answer:
              'Über die SCHUFA tauschen die teilnehmenden Vertragspartner:innen Zahlungsinformationen untereinander aus.<br/>' +
              '<br/>' +
              'Die SCHUFA-Auskunft beinhaltet beispielsweise folgende Informationen:' +
              '<ul>' +
              '<li>Personenbezogene Daten (Name, Anschrift, Geburtsdatum, Geburtsort)</li>' +
              '<li>Verträge & Konten: Girokonten, Kreditkarten, Ratenkredite, Leasingverträge, Telefonverträge, Bürgschaften</li>' +
              '<li>Angaben zur Zuverlässigkeit der Zahlung: z.B. Zahlungsstörungen, Informationen zu Insolvenzverfahren sowie Schuldnerverzeichniseinträge</li>' +
              '</ul>' +
              '<br/>' +
              '<strong>Nicht</strong> vermerkt werden:' +
              '<ul>' +
              '<li>Kontostände</li>' +
              '<li>Einkommen</li>' +
              '<li>Geldanlagen</li>' +
              '</ul>',
          },
          item12: {
            question: 'Wann bekomme ich einen SCHUFA-Eintrag?',
            answer:
              'Grundsätzlich dürfen Unternehmen Daten an die SCHUFA melden und eine SCHUFA-Auskunft anfordern, wenn sie ihren Kund:innen Kredite geben. Damit sind nicht nur die Kredite gemeint, die von Banken ausgegeben werden. Auch die Lieferung von Waren und Dienstleistungen, die von Kund:innen erst zu einem späteren Zeitpunkt bezahlt werden, gelten nach dem Verständnis der SCHUFA als Vergabe von Krediten. Dazu gehören auch Telekommunikationsunternehmen, Versandhandel und Energieversorgung.',
          },
          item13: {
            question: 'Wann werden SCHUFA-Einträge wieder gelöscht?',
            answer:
              'Die SCHUFA speichert Informationen über Personen nur für eine bestimmte Zeit. Maßgebliches Kriterium für die Festlegung dieser Zeit ist die Erforderlichkeit. Für eine Prüfung der Erforderlichkeit der weiteren Speicherung beziehungsweise die Löschung personenbezogener Daten hat die SCHUFA Regelfristen festgelegt. Danach beträgt die grundsätzliche Speicherdauer von personenbezogenen Daten jeweils drei Jahre taggenau nach deren Erledigung.<br/>' +
              '<br/>' +
              'Davon abweichend werden zum Beispiel gelöscht:' +
              '<ul>' +
              '<li>Angaben über Anfragen nach zwölf Monaten taggenau</li>' +
              '<li>Informationen über störungsfreie Vertragsdaten über Konten, die ohne die damit begründete Forderung dokumentiert werden (zum Beispiel Girokonten, Kreditkarten, Telekommunikationskonten oder Energiekonten), Informationen über Verträge, bei denen die Evidenzprüfung gesetzlich vorgesehen ist (zum Beispiel Pfändungsschutzkonten, Basiskonten) sowie Bürgschaften und Handelskonten, die kreditorisch geführt werden, unmittelbar nach Bekanntgabe der Beendigung.</li>' +
              '<li>Daten aus den Schuldner:innenverzeichnissen der zentralen Vollstreckungsgerichte nach drei Jahren taggenau, jedoch vorzeitig, wenn der SCHUFA eine Löschung durch das zentrale Vollstreckungsgericht nachgewiesen wird.</li>' +
              '<li>Informationen über Verbraucher:innen-/Insolvenzverfahren oder Restschuldbefreiungsverfahren taggenau drei Jahre nach Beendigung des Insolvenzverfahrens oder Erteilung der Restschuldbefreiung. In besonders gelagerten Einzelfällen kann auch abweichend eine frühere Löschung erfolgen.</li>' +
              '<li>Informationen über die Abweisung eines Insolvenzantrages mangels Masse, die Aufhebung der Sicherungsmaßnahmen oder über die Versagung der Restschuldbefreiung taggenau nach drei Jahren.</li>' +
              '<li>Personenbezogene Voranschriften bleiben taggenau drei Jahre gespeichert; danach erfolgt die Prüfung der Erforderlichkeit der fortwährenden Speicherung für weitere drei Jahre. Danach werden sie taggenau gelöscht, sofern nicht zum Zwecke der Identifizierung eine länger währende Speicherung erforderlich ist.</li>' +
              '</ul>' +
              '{SchufaDeletionPeriodTable}',
          },
          item14: {
            question: 'SCHUFA: Was bedeutet Scoring?',
            answer:
              'Scoring ist ein Verfahren, bei dem aus einer Menge von gesammelten Daten eine Prognose erstellt wird.<br/><br/>' +
              'Je mehr Daten zur Verfügung stehen, desto besser sind die Vorhersagen. Mit dem in Deutschland führenden Lösungsangebot von Auskunftei- und Informationsdienstleistungen für Unternehmen und Verbraucher:innen verfügt die SCHUFA über einen einzigartigen Datenbestand mit kreditrelevanten Informationen zu Personen und Unternehmen.<br/><br/>' +
              'Scorewerte, die die SCHUFA zu Verbraucher:innen berechnet, basieren auf den zu der Person bei der SCHUFA gespeicherten Daten. Zu den gespeicherten Informationen zählen die Anzahl und Art der Kreditaktivitäten, etwaige Zahlungsausfälle oder Informationen darüber, seit wann du schon Erfahrungen mit Kreditgeschäften gesammelt hast.<br/><br/>' +
              'Der <strong>SCHUFA-Basisscore</strong> wird branchenunabhängig erstellt und soll allgemein etwas darüber aussagen, wie hoch die Wahrscheinlichkeit ist, dass jemand vertragsgemäß ein Geschäft abwickelt. Der Basisscore ist ein Prozentwert, der alle drei Monate aktualisiert wird. Bei einem SCHUFA-Basisscore von 95 wird beispielsweise von einem geringen bis überschaubaren Ausfallrisiko ausgegangen.<br/><br/>' +
              'Es gibt <strong>branchenspezifische Scorewerte</strong>, da man für die Wahrscheinlichkeit, mit der jemand eine Rechnung bezahlt, eine andere Prognose abgeben muss als für die Wahrscheinlichkeit, mit der jemand einen Privatkredit zurückzahlt. Die branchenspezifischen Scorings werden von der SCHUFA nach eigenen Angaben nicht gespeichert, sondern tagesaktuell berechnet.',
          },
        },
        plusLinkButton: 'Zum SCHUFA-BonitätsCheck',
        basicLinkButton1: 'Für 29,95€ erstellen',
        basicLinkButton2: 'Mit Suchen+ erstellen',
      },
    },
    schufaCheckMieterPlus: {
      headline: 'Bonitätsauskunft',
      modal: {
        faq: {},
        image: 'Hände übergeben SCHUFA-BonitätsCheck Dokument',
        overview: {
          paragraph:
            'Original SCHUFA-BonitätsCheck, der von Plus-Mitgliedern einmal im Monat aktualisiert werden kann.',
          bullet1: 'Sofort online downloaden – auch von unterwegs',
          bullet2: 'Einmal bestellen und gleich an mehrere Vermieter schicken',
          bullet3: 'Erhöhe die Chance auf dein Traumzuhause',
          bullet4: 'Monatlich mit {MieterPlusLogo} aktualisieren',
          bullet4alt: '{MieterPlusLogo} freischalten und SCHUFA monatlich aktualisieren',
          notActive: 'Nicht mehr aktuell',
          paragraph2: 'Deine SCHUFA hat am {formattedDate} ihre Gültigkeit verloren.',
          activateFree: 'Jetzt aktualisieren',
          activateNow: 'Jetzt aktualisieren',
          activeUntilDate: 'Gültig bis {formattedDate}',
          verificationCode: 'Verifizierungscode : ',
          linkButton: 'Suchen+ für Miete entdecken',
        },
        howItWorks: {
          image1: 'Papier und Stift',
          image2: 'Geöffneter Briefumschlag',
          image3: 'Download-Symbol',
          paragraph1: 'Name, Anschrift und Geburtsdatum im Online-Formular angeben.',
          paragraph2: 'Dokument innerhalb von 3-5 Werktagen per Post erhalten.',
          paragraph3:
            '…oder einfach direkt herunterladen durch Online-Verifizierung via Ausweisdokument oder Online-Banking.',
        },
        ctaButtonSolvencyDocuments: 'Zur Bonitätsauskunft',
        ctaButtonNoSolvencyDocuments: 'Zum SCHUFA-BonitätsCheck',
      },
      schufaModal: {
        modalTitle: 'SCHUFA-BonitätsCheck',
        headline: 'Viele Vermieter:innen fordern eine offizielle Bonitätsauskunft',
        description: [
          'Von Vermieter:innen akzeptiert',
          'Zertifikat zur Weitergabe an die/den Vermieter:in (2 Monate gültig)',
          'In 3 Minuten erstellen & herunterladen',
        ],
        schufaIncluded: 'Für Suchen+ für Miete Mitglieder ',
        is24SolvencyIncluded: {
          prefix: 'Zusätzliches Suchen+ für Miete Angebot: ',
          link: 'ImmoScout24 Bonitätsauskunft',
        },
        schufaOriginalPrice: '29,95 €',
        schufaDiscounted: ' nur {discountedPrice} €',
        create: 'Jetzt erstellen',
        link: 'ImmoScout24 Bonitätsauskunft',
        alreadyBought: {
          text: 'Bereits bestellt? ',
          link: 'Jetzt einsehen',
        },
        closePreview: 'Verkleinern',
      },
      solvencyChoice: {
        solvency: {
          title: 'Bonitätsauskunft',
          schufa: {
            title: 'SCHUFA-BonitätsCheck',
          },
        },
        title: 'ImmoScout24 Bonitätsauskunft',
        subtitle: 'ImmoScout24 Bonitätsauskunft',
        goToSummary: 'Zum ausführlichen Ergebnis',
        description: [
          'Von Vermieter:innen akzeptiert',
          'Zertifikat zur Weitergabe an die/den Vermieter:in (3 Monate gültig)',
          'Nachvollziehbares Ergebnis (nur für dich sichtbar)',
        ],
        button: {
          addMoreSolvency: 'Weitere Bonitätsauskunft erstellen',
          closePreview: 'Verkleinern',
          create: 'In 3 Minuten erstellen',
        },
        headline: 'Viele Vermieter:innen fordern eine offizielle Bonitätsauskunft',
        alreadyBought: {
          text: 'Bereits bestellt? ',
          link: 'Jetzt einsehen',
        },
        schufaIncluded: {
          prefix: 'Zusätzlich inklusive: ',
          link: 'SCHUFA-BonitätsCheck erstellen',
        },
        schufaDiscounted: {
          prefix: 'Zusätzliches Suchen+ für Miete Angebot: ',
          link: 'SCHUFA-BonitätsCheck für {price}',
        },
        schufaFullPrice: {
          prefix: '',
          link: 'SCHUFA-BonitätsCheck für einmalig {price} inkl. MwSt.',
        },
        is24SolvencyIncluded: 'für Suchen+ für Miete Mitglieder <b>inklusive</b>',
        addByVerificationCode: {
          title: 'Gebe hier deinen Verifizierungscode ein',
          form: {
            verificationCode: {
              label: 'Verifizierungscode',
              placeholder: 'z.B. XXXX-XXXX-XXXXX',
              validation: {
                invalid: 'Der Verifizierungscode entspricht nicht dem Format "XXXX-XXXX-XXXXX".',
                missing: 'Der Verifizierungscode ist ungültig.',
              },
            },
            firstName: {
              label: 'Vorname',
              validation: {
                missing: 'Bitte gib deinen Vornamen ein.',
                capitalized: 'Bitte achte auf Groß- und Kleinschreibung.',
                invalid:
                  'Dein Vorname enthält unzulässige Zeichen. Bitte verwende nur Buchstaben (a-z,ä,ö,ü,ß) und Bindestriche (-).',
                short: 'Bitte gib mindestens 2 Buchstaben ein.',
              },
            },
            lastName: {
              label: 'Nachname',
              validation: {
                missing: 'Bitte gib deinen Nachnamen ein.',
                capitalized: 'Bitte achte auf Groß- und Kleinschreibung.',
                invalid:
                  'Dein Nachname enthält unzulässige Zeichen. Bitte verwende nur Buchstaben (a-z,ä,ö,ü,ß) und Bindestriche (-).',
                short: 'Bitte gib mindestens 2 Buchstaben ein.',
              },
            },
          },
          error: {
            notFound: {
              title: 'Ergebnis',
              message:
                'Der Code konnte nicht verifiziert werden. Bitte nutzen Sie die gleiche Schreibweise des Vor-sowie Nachnamens wie auf Ihrem Dokument und überprüfen Sie, ob der dazu passende Verifizierungscode richtig bzw. noch gültig ist. Nicht mehr gültige Verifizierungscodes werden nicht akzeptiert.',
            },
            technical: {
              title: 'Technischer Fehler',
              message:
                'Es ist leider ein technischer Fehler aufgetreten. Bitte versuche es zu einem anderen Zeitpunkt erneut.',
            },
          },
          backButton: 'Zurück',
          submit: {
            label: 'Fertig',
          },
        },
      },
    },
    applicationPackage: {
      headline: 'Vorstellungsmappe',
      modal: {
        image: 'Vorstellungsmappe wird überreicht',
        overview: {
          paragraph:
            'In der Vorstellungsmappe von ImmoScout24 befinden sich Unterlagen, die du zur Bewerbung auf dein neues Zuhause brauchen kannst. Alle Dokumente können innerhalb von wenigen Minuten online erstellt werden.',
          bullet1:
            'Automatisches Erstellen und Aktualisieren aller zur Bewerbung wichtigen Unterlagen - ganz ohne Papierkram',
          bullet2: 'In hochwertigem Design - digital oder zum Ausdrucken',
          bullet3: 'Anbietende vertrauen der ImmoScout24 Vorstellungsmappe',
          bullet4: 'In {BuyerPlusLogo} enthalten',
          slide1: 'Deckblatt',
          slide2: 'Selbstauskunft (1 von 2)',
          slide3: 'Selbstauskunft (2 von 2)',
          slide4: 'Käuferzertifikat',
          slide5: 'SCHUFA-BonitätsCheck',
          indicator: 'Indikator',
        },
        howItWorks: {
          image1: 'Mobiltelefon mit Profilansicht',
          image2: 'Vorstellungsmappe auf Papier und digital',
          image3: 'Vertragsabschluss',
          paragraph1: 'Bewerbungsdokumente im Profil innerhalb weniger Minuten automatisch erstellen oder hochladen.',
          paragraph2: 'Mit einem Klick wird aus den Dokumenten eine vollständige Vorstellungsmappe erstellt.',
          paragraph3:
            'Vorstellungsmappe als PDF herunterladen, ausdrucken, oder digital per Klick einer Nachricht anhängen.',
        },
        faq: {
          item0: {
            question: 'Welche Dokumente kann ich meiner Vorstellungsmappe hinzufügen?',
            answer:
              'Deiner Vorstellungsmappe kannst du alle Dokumente hinzufügen, welche die Anbietenden überzeugen könnten, dich als Käufer:in in Betracht zu ziehen. Dazu gehören unter anderem:' +
              '<ul>' +
              '<li>Selbstauskunft, welche die wichtigsten Daten zu deiner Person enthält</li>' +
              '<li>SCHUFA-Bonitätscheck, um den Anbietenden Zahlungsfähigkeit vorzuweisen</li>' +
              '<li>Finanzierungszertifikat, um deine Finanzierbarkeit bis zu einer bestimmten Summe im Vorfeld zu prüfen und nachzuweisen</li>' +
              '<li>Weitere relevante Dokumente (wie z.B.: Finanzierungsbestätigung, Eigenkapitalnachweise etc.) kannst du unter Eigene Dokumente hinzufügen</li>' +
              '</ul>',
          },
          item1: {
            question: 'Kann ich die Vorstellungsmappe auch mit einer weiteren Person benutzen?',
            answer:
              'Du kannst die Vorstellungsmappe auch für zwei oder mehrere Personen nutzen. Dazu kannst du die Dokumente von weiteren Personen ganz einfach über "Eigene Dokumente" hinzufügen.',
          },
          item2: {
            question: 'Kann ich die Vorstellungsmappe anschließend auch ausdrucken?',
            answer:
              'Das Herunterladen der Vorstellungsmappe als PDF ist für dich als Suchen+ für Kauf Mitglied möglich. Die PDF kannst du im Menüpunkt <BuyerReportPageLink>Profil & Dokumente</BuyerReportPageLink> über den "Herunterladen" Knopf generieren.',
          },
        },
        linkButtonWithMieterPlus: 'Zu meiner Vorstellungsmappe',
        linkButtonWithoutMieterPlus: 'Suchen+ entdecken',
      },
    },
    applicationPackageMieterPlus: {
      headlineOne: 'Bewerbermappe',
      headlineTwo: 'Profil & Dokumente',
      modal: {
        image: 'Bewerbermappe wird überreicht',
        overview: {
          paragraph:
            'In der Bewerbermappe von ImmoScout24 befinden sich alle Unterlagen, die du zur Bewerbung auf dein neues Zuhause benötigst. Alle Dokumente können innerhalb von wenigen Minuten online erstellt werden.',
          bullet1:
            'Automatisches Erstellen und Aktualisieren aller zur Bewerbung wichtigen Unterlagen - ganz ohne Papierkram',
          bullet2: 'In hochwertigem Design - digital oder zum ausdrucken',
          bullet3: 'Anbieter:innen vertrauen der ImmoScout24 Bewerbermappe',
          bullet4: 'In {MieterPlusLogo} enthalten',
          slide1: 'Deckblatt',
          slide2: 'Selbstauskunft (1 von 2)',
          slide3: 'Selbstauskunft (2 von 2)',
          slide4: 'SCHUFA-BonitätsCheck',
          slide5: 'Identitätsnachweis',
          slide6: 'Einkommensnachweis',
          slide7: 'Mietzahlungsnachweis (1 von 2)',
          slide8: 'Mietzahlungsnachweis (2 von 2)',
          slide9: 'Eigene Dokumente',
          indicator: 'Indikator',
          alternateText: {
            bigText: 'Dein Profil kombiniert alle wichtigen Daten zu deiner Person.',
            smallTextOne:
              'Mit deinen persönlichen Angaben, Kontaktdaten, Wunschvorstellungen und relevanten Dokumenten, wie SCHUFA BonitätsCheck und Selbstauskunft bekommen Anbieter:innen einen umfassenden Eindruck von dir.',
            smallTextTwo:
              'Und mit der exklusiven und professionellen Suchen+ für Miete Bewerbermappe erstellst du mit nur wenigen Klicks deine Einkommens-, Mietzahlungs- und Identitätsnachweise – alles digital, ganze ohne Scannen und Papierchaos.',
            smallTextThree:
              'So präsentierst du dich bestmöglich bei deinen zukünftigen Vermieter:innen und erleichterst ihnen die Arbeit.',
          },
        },
        howItWorks: {
          image1: 'Mobiltelefon mit Profilansicht',
          image2: 'Vorstellungsmappe auf Papier und digital',
          image3: 'Vertragsabschluss',
          paragraph1: 'Bewerbungsdokumente im Profil innerhalb weniger Minuten automatisch erstellen oder hochladen.',
          paragraph2: 'Mit einem Klick wird aus den Dokumenten eine vollständigen Bewerbermappe erstellt.',
          paragraph3:
            'Bewerbermappe als PDF herunterladen, ausdrucken, oder digital per Klick einer Nachricht anhängen.',
        },
        faq: {},
        linkButtonWithMieterPlus: 'Zu meiner Bewerbermappe',
        linkButtonWithoutMieterPlus: 'Zu meinem Profil',
        linkDiscoverMieterPlus: 'Suchen+ für Miete entdecken',
      },
    },
    valuation: {
      headline: 'Immobilienbewertung',
      modal: {
        image: 'Smartphone Display zeigt Haus und Bewertungsdaten',
        overview: {
          paragraph1:
            'Du hast eine attraktive Immobilie gefunden und möchtest nun schnell wissen, ob der Verkaufspreis dem aktuellen Marktpreis entspricht?',
          paragraph2:
            'Damit Du abgesichert in die Preisverhandlung mit den Verkaufenden gehen kannst, ermitteln wir anhand umfangreicher Daten den aktuellen Marktwert und zusätzlich, wie sich der Wert in den nächsten Jahren entwickeln könnte.',
          bullet1: 'Wertermittlung in wenigen Minuten',
          bullet2: 'Ausblick auf die nächsten 2 Jahre',
          bullet3: 'In {BuyerPlusLogo} enthalten',
        },
        howItWorks: {
          image1: 'Haus mit Wert',
          image2: 'Diagramme',
          image3: 'Wiederholungszeichen',
          paragraph1:
            'Mit nur ein paar Daten erhältst du eine aktuelle Bewertung deiner Immobilie. Jeden Monat kannst du so viele Objekte bewerten, wie du magst.',
          paragraph2:
            'Zu jeder Bewertung erhälst du eine Detailansicht, die dir zeigt, wie sich der Immobilienwert voraussichtlich in den nächsten 2 Jahren entwickeln wird.',
          paragraph3:
            'Wir checken für dich alle 3 Monate, ob sich der errechnete Wert der Immobilie verändert hat. In diesem Fall kannst du mit nur einem Klick den Wert einfach aktualisieren.',
        },
        faq: {},
        linkButton: 'Immobilie bewerten',
        overviewButton: 'Meine Bewertungen',
        unlockBuyerPlusButton: 'Suchen+ entdecken',
        contingent:
          'Du hast diesen Monat bereits <b>5 Bewertungen</b> durchgeführt. Nächsten Monat kannst du wieder 5 Bewertungen vornehmen.',
      },
    },
    realEstateProof: {
      headline: 'DEKRA Immobilienprüfung',
      modal: {
        image: 'Mann inspiziert Gebäude',
        overview: {
          paragraph1: 'Sicherer Hausbau durch frühzeitiges Entdecken von Mängeln oder Schäden.',
          paragraph2:
            'Ein neutraler Sachverständiger hilft Dir als Bauherr, den Zeit- und Kostenrahmen des Projektes einzuhalten. DEKRA führt bei Deinem Neubau-Projekt nach festgelegten Bauabschnitten neutrale Checks durch. Werden Mängel rechtzeitig festgestellt und beseitigt, bleibt Dein Projekt im Zeitplan und das trägt dazu bei, dass Du wie geplant einziehen kannst.',
          bullet1: '15% Rabatt für {BuyerPlusLogo}',
          bullet2: 'Betreuung durch DEKRA Sachverständigen',
          bullet3: 'Vor-Ort-Begehungen je nach Baufortschritt',
          bullet4: 'Kontrolle des Ausführungsstands',
          bullet5: 'Erstellung von Berichten mit Fotodokumentation',
          bullet6: 'Nur für Neubauprojekte',
        },
        howItWorks: {
          image1: 'Papier und Stift',
          image2: 'Kalender',
          image3: 'Person',
          paragraph1:
            'Bereits bevor Mängel an deiner Immobilie dir das Leben schwer machen, kannst du Hilfe bei DEKRA anfordern. Gebe im nächsten Schritt Deine Kontaktdaten und eine kurze Problem-beschreibung an.',
          paragraph2: 'Du bekommst innerhalb weniger Tage Terminvorschläge für eine unverbindliche Beratung.',
          paragraph3:
            'In einem persönlichen Gespräch wird das Problem besprochen, dein Bedarf besprochen und ein Angebot inklusive dem exklusiven Rabatt von 15% erstellt.',
        },
        faqHeadline1: 'Anwendungsfälle',
        faqHeadline2: 'Kosten & Ablauf',
        faq: {
          item0: {
            question: 'In welchen Fällen würde ich als Käufer Gebrauch von diesem Service machen?',
            answer:
              'Als Bauherr musst du dir bei Neu-, Umbau- oder Sanierungsmaßnahmen meist mehrere Partner mit ins Boot holen.<br/>' +
              'Fehler sind vorprogrammiert – manche davon machen sich erst nach Jahren schmerzhaft bemerkbar. Sachverständige von DEKRA dokumentieren in zeitlich dem Baufortschritt angepassten Begehungen den Ausführungszustand der Bauarbeiten.<br/>' +
              'Das Ziel ist es, ärgerliche und kostspielige Ausführungsfehler frühzeitig zu erkennen und diese noch rechtzeitig während der Bauphase zu beheben.',
          },
          item1: {
            question: 'Rentiert sich eine Immobilienprüfung auch bei Bestandsimmobilien?',
            answer:
              'Die Immobilienprüfung wird nur für Neubauprojekte angewendet. Bei Bestandsimmobilien empfehlen wir die Zustandsbewertung für Bestandsgebäude.',
          },
          item2: {
            question: 'Kann ich diesen Service nur bei Neubau-Projekten nutzen?',
            answer:
              'Ja, die Immobilienprüfung ist eine baubegleitende Prüfung. Die neutralen Experten von DEKRA prüfen und dokumentieren Bauphase für Bauphase den Ausführungszustand der Arbeiten. Wenn es sich um ein Bestandsobjekt handelt, empfehlen wir die Zustandsbewertung von Gebäuden und Wohnungen.',
          },
          item3: {
            question: 'Kann ich diesen Service nur bei bestehenden Mängeln nutzen, oder auch zur Vorsorge?',
            answer:
              'Die Immobilienprüfung ist eine präventive Baubegleitung, um mögliche Ausführungsfehler der Bauarbeiten frühzeitig zu erkennen. Wenn bereits Schäden aufgetreten sind, empfehlen wir das DEKRA Bauschadengutachten.',
          },
          item4: {
            question:
              'Was ist der Unterschied zwischen der "DEKRA Immobilienprüfung" und dem "DEKRA Bauschadengutachten"?',
            answer:
              'Die DEKRA Immobilienprüfung ist eine Baubegleitung, bei der mögliche Ausführungsfehler bzw. Mängel der Bauarbeiten frühzeitig erkannt und dokumentiert werden. Dadurch können sie oft ohne größeren Aufwand beseitigt werden.<br/>' +
              'Das DEKRA Bauschadengutachten kommt dann zur Anwendung, wenn aufgrund eines Mangels ein bestimmter Bauschaden (z. B. Feuchteschaden) entstanden ist und begutachtet werden muss. Durch die gezielte Ursachenermittlung kann der Schaden dann beseitigt werden.',
          },
          item5: {
            question: 'Wie viel kostet eine Immobilienprüfung für gewöhnlich?',
            answer:
              'Da jede Prüfung sehr individuell ist und davon abhängig ist wie groß der Prüfungsumfang ist, kann hier keine exakte Angabe gemacht werden. Die Angebotserstellung ist aber kostenfrei und stellt auch keinen verbindlichen Vertrag dar.',
          },
          item6: {
            question: 'Ist die Angebotserstellung kostenfrei?',
            answer: 'Ja, die Angebotserstellung ist kostenfrei und unverbindlich.',
          },
          item7: {
            question: 'Wie kann ich diesen Service nutzen?',
            answer: 'Weitere Informationen zu dem Ablauf kannst Du unter dem “So funktioniert’s” Tab finden.',
          },
          item8: {
            question: 'Was macht DEKRA?',
            answer:
              'Die DEKRA Bausachverständigen prüfen Dein Objekt in allen wichtigen Phasen:' +
              '<ul>' +
              '<li>Baubegleitend, damit mögliche Ausführungsfehler frühzeitig erkannt werden</li>' +
              '<li>Bei der Endabnahme, die sie als neutraler Dritter begleiten</li>' +
              '<li>Vor Ablauf der Gewährleistung, damit Du eventuelle Bau- oder Gewährleistungsmängel später nicht auf eigene Kosten beheben lassen musst</li>' +
              '</ul>' +
              'Nähere Informationen zu den DEKRA Leistungen erhältst Du im Zuge der Angebotserstellung durch DEKRA.',
          },
          item9: {
            question: 'Kann ich auch direkt Bilder zur Prüfung hochladen?',
            answer:
              'Nein. Im ersten Schritt übergeben wir das Interesse an einer Immobilienprüfung bzw. Der Erstellung eines Angebotes an DEKRA. In den folgenden Schritten entscheidet DEKRA dann, was zur Angebotserstellung benötigt wird.',
          },
          item10: {
            question: 'Was passiert mit meinen übermittelten Daten?',
            answer:
              'Deine DEKRA Niederlassung vor Ort meldet sich bei dir für alle Details, um ein Angebot zu erstellen und den Termin vor Ort abzustimmen.<br/>' +
              'Die Verarbeitung personenbezogener Daten für vorvertragliche oder vertragliche Zwecke erfolgt auf Basis von Art. 6 Abs. 1 DSGVO.<br/>' +
              'Speicherdauer: Soweit erforderlich, verarbeiten und speichern wir Ihre personenbezogenen Daten für die Dauer unserer Geschäftsbeziehung. Darüber hinaus unterliegen wir Aufbewahrungs- und Dokumentationspflichten die sich aus dem Handelsgesetzbuch sowie der Abgabenordnung ergeben. Schließlich beurteilt sich die Speicherdauer auch nach gesetzlichen Verjährungsfristen.',
          },
          item11: {
            question: 'Welchen Vorteil bekomme ich als Plus-Mitglied, abgesehen vom Rabatt?',
            answer: 'Plus Mitglieder erhalten einen Rabatt in Höhe von 15% auf die aktuellen DEKRA Honorartabellen.',
          },
        },
        linkButton: 'Angebot anfordern',
      },
    },
    realEstateDamageReport: {
      headline: 'DEKRA Bauschadengutachten',
      modal: {
        image: 'Mann auf Baustelle schaut auf Plan',
        overview: {
          subHeading: 'Gutachten und Empfehlung zur Behebung von Schäden.',
          paragraph:
            'Wenn Schäden am Gebäude auftreten, ist schnelles und sorgfältiges Vorgehen erforderlich. Ein Bauschadengutachten durch die DEKRA Sachverständigen geht den Ursachen auf den Grund und dokumentiert das Ausmaß. Zum möglichen Leistungsumfang gehören auch die Beschreibung zu notwendigen Instandsetzungsmaßnahmen und die Ermittlung der Kosten.',
          bullet1: '15% Rabatt für {BuyerPlusLogo}',
          bullet2: 'Vor-Ort-Begehung mit Schadensfeststellung',
          bullet3: 'Beurteilung des Schadensumfangs und der Schadensursache',
          bullet4: 'Beschreibung von Instandsetzungsmaßnahmen',
          bullet5: 'Optionale Kostenschätzung',
        },
        howItWorks: {
          image1: 'Zwei Papierblätter und ein Stift',
          image2: 'Kalender mit Häckchen',
          image3: 'Anzugträger',
          paragraph1:
            'Du hast einen Schaden an deiner Immobilie festgestellt und brauchst professionelle Unterstützung? Dann kannst du Hilfe bei DEKRA anfordern. Gebe im nächsten Schritt Deine Kontaktdaten und eine kurze Problembeschreibung an.',
          paragraph2: 'Du bekommst innerhalb weniger Tage Terminvorschläge für eine unverbindliche Beratung.',
          paragraph3:
            'In einem persönlichen Gespräch wird das Problem besprochen, dein Bedarf besprochen und ein Angebot inklusive dem exklusiven Rabatt von 15% erstellt.',
        },
        faqHeadline1: 'Anwendungsfälle',
        faqHeadline2: 'Kosten & Ablauf',
        faq: {
          item0: {
            question: 'In welchen Fällen würde ich als Käufer Gebrauch von diesem Service machen?',
            answer:
              'Bei Bauschäden oder Baumängeln am Gebäude – etwa durch Schimmel oder Feuchtigkeit – ist eine schnelle und genaue Untersuchung unerlässlich. Die Dekra Sachverständigen ermitteln für Dich die Schadensursache, geeignete Wege zur Schadenbeseitigung sowie die damit verbundenen Kosten.',
          },
          item1: {
            question: 'Rentiert sich ein Bauschadengutachten auch bei Neubauten?',
            answer:
              'Ein Bauschadengutachten rentiert sich sowohl in der Bauphase, beim Neubau, wie auch beim Bestandsgebäude. Egal in welcher Phase der Bauwerkserstellung bzw. Nutzungsdauer ein Schaden/Mangel auftritt kann sich ein Bauschadengutachten rentieren. So Hilft ein DEKRA-Bauschadengutachten Ursachen wie auch Verantwortlichkeiten festzustellen und zu bewerten.',
          },
          item2: {
            question: 'Kann ich diesen Service auch während der Bauphase eines Neubaus nutzen?',
            answer:
              'Ein Bauschadengutachten rentiert sich sowohl in der Bauphase, beim Neubau, wie auch beim Bestandsgebäude. Egal in welcher Phase der Bauwerkserstellung bzw. Nutzungsdauer ein Schaden/Mangel auftritt kann sich ein Bauschadengutachten rentieren. So Hilft ein DEKRA-Bauschadengutachten Ursachen wie auch Verantwortlichkeiten festzustellen und zu bewerten.',
          },
          item3: {
            question: 'Kann ich diesen Service nur bei bestehenden Mängeln nutzen, oder auch zur Vorsorge?',
            answer:
              'Ja, das Bauschadengutachten ist eine Begutachtung<br/>' +
              'aufgetretener Bauschäden/-mängel an Deinem Haus oder Deiner Wohnung.<br/>' +
              'Zur Vorsorge empfiehlt sich die DEKRA-Immobilienprüfung.',
          },
          item4: {
            question:
              'Was ist der Unterschied zwischen der "DEKRA Immobilienprüfung" und dem "DEKRA Bauschadengutachten"?',
            answer:
              'Die DEKRA Immobilienprüfung ist eine Baubegleitung, bei der mögliche Ausführungsfehler bzw. Mängel der Bauarbeiten frühzeitig erkannt und dokumentiert werden. Dadurch können sie oft ohne größeren Aufwand beseitigt werden.<br/>' +
              'Das DEKRA Bauschadengutachten kommt dann zur Anwendung, wenn aufgrund eines Mangels ein bestimmter Bauschaden (z. B. Schimmel- oder Feuchteschaden) entstanden ist und begutachtet werden muss. So hilft ein DEKRA-Bauschadengutachten Ursachen wie auch Verantwortlichkeiten festzustellen und zu bewerten.',
          },
          item5: {
            question: 'Wie viel kostet ein Bauschadengutachten für gewöhnlich?',
            answer:
              'Da jede Prüfung sehr individuell ist und davon abhängig ist wie groß der Prüfungsumfang ist, kann hier keine exakte Angabe gemacht werden. Die Angebotserstellung ist aber kostenfrei und stellt auch keinen verbindlichen Vertrag dar.',
          },
          item6: {
            question: 'Ist die Angebotserstellung kostenfrei?',
            answer: 'Ja, die Angebotserstellung ist kostenfrei.',
          },
          item7: {
            question: 'Wie kann ich diesen Service nutzen?',
            answer: 'Weitere Informationen zu dem Ablauf kannst Du unter dem “So funktioniert’s” Tab finden.',
          },
          item8: {
            question: 'Was macht DEKRA?',
            answer:
              'DEKRA erstellt für Dich Gutachten bei Schäden/Mängeln an und in Gebäuden, Nebengebäuden sowie an allen Gebäude- und Grundstücksbestandteilen wie Toren, Zäunen und sonstigen Grundstückseinfassungen. Zum Leistungsumfang gehören die Feststellungen zur Ursache und Verantwortlichkeiten wie auch die Beschreibung möglicher Instandsetzungsmaßnahmen und die Ermittlung deren Kosten.',
          },
          item9: {
            question: 'Kann ich auch direkt Bilder zur Prüfung hochladen?',
            answer:
              'Nein. Im ersten Schritt übergeben wir das Interesse an einem Bauschadengutachten bzw. der Erstellung eines Angebotes an DEKRA. In den folgenden Schritten entscheidet DEKRA dann, was zur Angebotserstellung benötigt wird.',
          },
          item10: {
            question: 'Was passiert mit meinen übermittelten Daten?',
            answer:
              'Deine DEKRA Niederlassung vor Ort meldet sich bei dir für alle Details, um ein Angebot zu erstellen und den Termin vor Ort abzustimmen.<br/>' +
              'Die Verarbeitung personenbezogener Daten für vorvertragliche oder vertragliche Zwecke erfolgt auf Basis von Art. 6 Abs. 1 DSGVO.<br/>' +
              'Speicherdauer: Soweit erforderlich, verarbeiten und speichern wir Ihre personenbezogenen Daten für die Dauer unserer Geschäftsbeziehung. Darüber hinaus unterliegen wir Aufbewahrungs- und Dokumentationspflichten die sich aus dem Handelsgesetzbuch sowie der Abgabenordnung ergeben. Schließlich beurteilt sich die Speicherdauer auch nach gesetzlichen Verjährungsfristen.',
          },
          item11: {
            question: 'Welchen Vorteil bekomme ich als Plus-Mitglied, abgesehen vom Rabatt?',
            answer: 'Plus Mitglieder erhalten einen Rabatt in Höhe von 15% auf die aktuellen DEKRA Honorartabellen.',
          },
        },
        linkButton: 'Angebot anfordern',
      },
    },
    legalInsurance: {
      headline: 'ARAG Nachbarschafts-Rechtsschutz',
      modal: {
        headline: 'Nachbarschafts-Rechtsschutz',
        image: 'Neubau im Sonnenschein',
        details: {
          startDate: 'Startdatum',
          endDate: 'Enddatum',
          explenatory:
            'Dein ARAG Nachbarschafts-Rechtsschutz ist aktiviert und steht dir bis zum Ablauf von 12 Monaten zur Verfügung. Nach Ablauf der Laufzeit kannst du deinen Schutz gerne bei der ARAG verlängern.',
          active: {
            title: 'Versicherungsschutz aktiviert!',
            text: 'Dein Nachbarschafts-Rechsschutz der ARAG ist aktiviert.',
          },
          legalInsuranceNumberHeader: 'Deine Vertragsnummer',
          legalInsuranceNumber: '11008213767342',
          downloadDocument: 'Versicherungsausweis herunterladen',
          companyData: {
            contactInfo:
              'Du hast eine Frage oder möchtest einen Schadensfall melden? Der Nachbarschafts-Rechtsschutz der ARAG ist für dich da. Mehr Informationen findest du auf deinem Versicherungsschein zum Download.',
            title1: '<b>ARAG SE</b>{br}ARAG Platz 1',
            title2: '40472 Düsseldorf',
            phone: '0211 / 9890 1886',
            email: 'service@arag.de',
          },
        },
        overview: {
          paragraph1: 'Unterstützung bei Rechtsfragen mit dem ARAG Nachbarschafts-Rechtsschutz',
          paragraph2:
            'Bei Streitigkeiten rund um Deine Immobilie hast Du jemanden an Deiner Seite. Der ARAG Nachbarschafts- Rechtsschutz schützt Dich und steht Dir kostenfrei für ein Jahr zur Verfügung.',
          bullet1: 'Die gesetzliche Vergütung deiner Rechtsvertretung',
          bullet2: 'Gerichtskosten einschließlich Sachverständigen',
          bullet3: 'Verfahrenskosten von Verwaltungsbehörden',
          bullet4: 'Keine Selbstbeteiligung',
          bullet5: '1 Jahr in 6 & 12 Monaten {BuyerPlusLogo} enthalten',
        },
        howItWorks: {
          image1: 'Police',
          image2: 'Waage',
          image3: 'Telefonhörer',
          paragraph1:
            'Nach der Aktivierung des ARAG Nachbarschafts-Rechtsschutzes erhältst du die Kontaktinformationen für den Schadensfall und deine Versicherungsunterlagen einfach per Mail.',
          paragraph2:
            'Nach 3 Monaten Wartezeit beginnt der vollumfängliche Schutz und du kannst dich direkt an die ARAG wenden. Dafür brauchst du nur deine registrierte E-Mail anzugeben und deine Vertragsnummer.',
          paragraph3:
            'Wenn du den Rechtsschutz brauchst, dann melde dich einfach bei der ' +
            'ARAG SE unter {PhoneNumber} oder per E-Mail an {EMail}.<br/>' +
            'Dafür brauchst du nur deine registrierte E-Mail anzugeben und deine Vertragsnummer.',
          phoneNumber: '0211 / 9890 1886',
          eMail: 'service@arag.de',
        },
        faq: {
          item0: {
            question: 'In welchen Fällen greift die Rechtsschutzversicherung?',
            answer:
              'Bei Streitigkeiten rund um deine Immobilie hast du einen Partner an deinen Seite. Der ARAG Nachbarschafts- Rechtsschutz schützt dich u.a. mit der Kostenübernahme für:' +
              '<ul>' +
              '<li>die gesetzliche Vergütung des Rechtsanwalts,</li>' +
              '<li>Gerichtskosten einschließlich Sachverständigen,</li>' +
              '<li>Verfahrenskosten von Verwaltungsbehörden</li>' +
              '</ul>' +
              '<br/>' +
              'Die Versicherungsbedingungen zum ARAG Nachbarschafts-Rechtsschutz kannst du <insuranceAgb>hier</insuranceAgb> herunterladen.',
          },
          item1: {
            question:
              'Warum ist eine Aktivierung erforderlich, wenn die Versicherung doch Teil meiner Plus-Mitgliedschaft ist?',
            answer:
              'Du hast als Suchen+ für Kauf Mitglied die Wahl, ob du die Versicherung nutzen möchtest oder nicht. Außerdem geben wir nur die Nutzer Daten an unseren Partner ARAG weiter, wo tatsächlich eine Aktivierung erfolgt ist. Damit stellen wir auch die Datensicherheit unserer Nutzer sicher. ',
          },
          item2: {
            question: 'Gibt es eine Mindestvertragslaufzeit?',
            answer:
              'Als Suchen+ für Kauf Mitglied kannst du den ARAG Nachbarschafts-Rechtsschutz für ein Jahr kostenfrei aktivieren. Der Rechtsschutz läuft nach diesem Jahr automatisch aus. Eine Mindestvertragslaufzeit gibt es nicht. ',
          },
          item3: {
            question: 'Verlängert sich die Rechtschutzversicherung automatisch?',
            answer:
              'Nein, dein ARAG Nachbarschafts-Rechtsschutz läuft nach einem Jahr aus und wird nicht automatisch verlängert.',
          },
          item4: {
            question: 'Was passiert nach Kündigung meiner Mitgliedschaft?',
            answer:
              'Sobald du den ARAG Nachbarschafts-Rechtsschutz aktiviert hast, läuft dieser genau 1 Jahr. Wenn du in dieser Zeit deine Suchen+ für Kauf Mitgliedschaft kündigst, bleibt dein ARAG Nachbarschafts-Rechtsschutz davon unberührt. ',
          },
        },
        linkButton: 'Versicherungsschutz aktivieren',
      },
    },
  },
  modal: {
    tabs: {
      label: 'Beschreibung der Merkmale',
      overview: 'Übersicht',
      howItWorks: "So funktioniert's",
      faqs: 'FAQs',
      terms: 'Nutzungsbedingungen',
    },
  },
  welcomeModal: {
    banner: {
      title: 'Ab sofort kannst du alle Vorteile von {BuyerPlusLogo} nutzen!',
      welcomeText: 'Herzlichen Glückwunsch, {FirstName}!',
      welcomeTextNoName: 'Herzlichen Glückwunsch!',
    },
    livingUpsell: {
      header: {
        part1: 'Dein Upgrade für mehr',
        part2: 'Miet-Sicherheit: Wohnen',
        full: 'Dein Upgrade für mehr Miet-Sicherheit: Wohnen',
      },
      subheader: {
        part1: 'Mit Mieter',
        part2: 'erhältst du bis zu {discounts}% Willkommensrabatt.',
      },
      explanationText:
        'Ob Kaution, Mietminderung oder Nebenkosten – dich stresst nichts mehr. Denn dein neuer Mietschutz ist immer da, wenn du ihn brauchst - schon ab {lowestMonthlyCost}€/Monat.',
      card: {
        perMonth: '/ Monat',
        oneTime: 'Einmalig',
      },
      buttonText: {
        learnMore: 'Mehr erfahren',
        continueToPayment: 'Weiter zur Bezahlung',
      },
      subscriptionOptions: {
        monthly: {
          title: 'Monatlich',
          subtitle: '12 Monate Mindestlaufzeit',
        },
        yearly: {
          title: '12 Monate',
        },
        biYearly: {
          title: '24 Monate',
        },
      },
    },
    wohnenUpsell: {
      de: {
        header: 'Dein Upgrade für mehr Miet-Sicherheit: ',
        wohnenPlusS: 'Wohnen+ S',
        subheader: 'Mit Suchen+ für Miete erhältst du bis zu {percentage}% Willkommensrabatt.',
        explanationText:
          'Ob Kaution, Mietminderung oder Nebenkosten - dich stresst nichts mehr. Denn dein neuer Mietschutz ist immer da, wenn du ihn brauchst - schon ab {lowestMonthlyCost}€ / Monat.',
        aragPartnership: 'In Partnerschaft mit ARAG',
        buttonText: {
          otherOptions: 'Mehr erfahren',
          continueToPayment: 'Weiter zur Bezahlung',
        },
        subscriptionOptions: {
          priceTitleMonthly: '<strong>{monthlyPrice} €</strong> / Monat',
          priceTitleYearly: '<strong>{yearlyPrice} €</strong> / Jahr',
          monthly: {
            title: 'Monatlich',
            subtitle: '12 Monate Mindestlaufzeit',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
          yearly: {
            title: 'Jährlich',
            subtitle: '12 Monate Mindestlaufzeit',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
        },
      },
      en: {
        header: 'Protect yourself and your home with ',
        wohnenPlusS: 'Wohnen+ S',
        subheader: 'As a Suchen+ member, you receive up to {percentage}% discount',
        explanationText:
          "Whether it's a deposit, rent increase, or utility costs - nothing stresses you out anymore. Your new tenant protection is always there when you need it - starting from {lowestMonthlyCost} € / month.",
        aragPartnership: 'In partnership with ARAG',
        buttonText: {
          otherOptions: 'Learn more',
          continueToPayment: 'Proceed to checkout',
        },
        subscriptionOptions: {
          priceTitleMonthly: '<strong>{monthlyPrice} €</strong> / month',
          priceTitleYearly: '<strong>{yearlyPrice} €</strong> / year',
          monthly: {
            title: 'Monthly',
            subtitle: '12 Month minimum term',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
          yearly: {
            title: 'Yearly',
            subtitle: '12 Month minimum term',
            priceBenefit: '<s>{originalPrice} €</s>',
          },
        },
      },
    },
    wohnenPlusLight: {
      title: 'Wohnen+ Light',
      badge: '12 Monate geschenkt',
      headline: 'Spar dir Geld mit {WohnenPlusLogo} Light',
      subheadline: 'Wir schenken dir 12 Monate Wohnen+ Light. Danach nur 1,99 €/Monat, monatl. kündbar.',
      benefit1: 'Bis zu 15 % bei Wohn-Services sparen',
      benefit2: 'Bis zu 40 % beim Strom sparen, ohne Grundgebühr',
      benefit3: 'Kostenlos Nebenkosten prüfen lassen – statt 49 €',
      benefit4: 'Übersicht über deine Wohnung behalten',
      benefit5: 'Inkludierte Hilfe bei Wohn- und Mietfragen',
      disclaimer:
        '*Nach Ablauf der 12-monatigen kostenfreien Laufzeit verlängert sich die Mitgliedschaft automatisch auf unbestimmte Zeit zum Monatspreis von 1,99 €, jederzeit mit einer Frist von 1 Monat kündbar. Es gelten unsere AGB und unsere Widerrufsbelehrung. Alle Preise inkl. MwSt.',
      cta: {
        buyNow: 'Jetzt kaufen',
        decline: 'Auf Geschenk verzichten',
      },
      success: {
        title: 'Herzlichen Glückwunsch, {FirstName}!',
        titleNoName: 'Herzlichen Glückwunsch!',
        subtitle: 'Ab sofort kannst du alle Vorteile von Wohnen+ Light für 12 Monate nutzen!',
      },
      error: {
        title: 'Technischer Fehler',
        message: 'Das hat leider nicht funktioniert. Versuchs später nochmal.',
      },
    },
  },
  livingPlusBanner: {
    description: 'Mit {WohnenPlusLink} hast du mehr als nur ein neues Zuhause – du hast Sicherheit',
  },
  legalInsuranceHint: {
    imageAlt: 'Glühbirne',
    title: 'Tipp: ',
    preText: 'Der ',
    buttonText: 'Nachbarschafts-Rechtsschutz',
    postText: ' muss 3 Monate vor der Nutzung aktiviert werden!',
  },
  membershipManagement: 'Mitgliedschaft verwalten',
  faq: {
    title: 'Fragen zur Mitgliedschaft',
    accordion: {
      section1: {
        premium: {
          title: 'Wie kann ich meine Plus-Mitgliedschaft kündigen?',
          description:
            'Die gebuchte Plus-Mitgliedschaft kann innerhalb der Mindestvertragslaufzeit zum Ende der Mindestvertragslaufzeit gekündigt werden oder danach monatlich zum Laufzeitende. Die Kündigung kannst Du selbstständig {Link} vornehmen. Bei einer jährlichen bzw. zweijährlichen Wohnen+ Mitgliedschaft geschieht dies automatisch.',
        },
        livingBundle: {
          title: 'Wie kann ich meine Plus-Mitgliedschaft kündigen?',
          description:
            'Die gebuchte Plus-Mitgliedschaft kann innerhalb der Mindestvertragslaufzeit zum Ende der Mindestvertragslaufzeit gekündigt werden oder danach monatlich zum Laufzeitende. Die Kündigung kannst Du selbstständig {Link} vornehmen.',
        },
        mieterPlus: {
          title: 'Wie kann ich meine Plus-Mitgliedschaft kündigen?',
          description:
            'Die gebuchte Plus-Mitgliedschaft kann innerhalb der Mindestvertragslaufzeit zum Ende der Mindestvertragslaufzeit gekündigt werden oder danach monatlich zum Laufzeitende. Die Kündigung kannst Du selbstständig {Link} vornehmen.',
        },
        wohnenPlusLight: {
          title: 'Wie kann ich meine Wohnen+ Light Mitgliedschaft kündigen?',
          description:
            'Die gebuchte Wohnen+ Light Mitgliedschaft kann innerhalb der Mindestvertragslaufzeit zum Ende der Mindestvertragslaufzeit gekündigt werden oder danach monatlich zum Laufzeitende. Die Kündigung kannst Du selbstständig {Link} vornehmen.',
        },
        kaeuferPlus: {
          title: 'Wie kann ich meine Plus-Mitgliedschaft kündigen?',
          description:
            'Die gebuchte Plus-Mitgliedschaft kann innerhalb der Mindestvertragslaufzeit zum Ende der Mindestvertragslaufzeit gekündigt werden oder danach monatlich zum Laufzeitende. Die Kündigung kannst Du selbstständig {Link} vornehmen.',
        },
        linkText: 'hier',
        linkTitle: 'Zur Vertragsübersicht',
      },
      section2: {
        premium: {
          title: 'Wieso habe ich eine Plus-Mitgliedschaft?',
          description:
            '<p>Wenn Du den SCHUFA-BonitätsCheck bestellst, erhältst du auch die Möglichkeit, die Plus-Mitgliedschaft für einen Monat zu testen. Sicherlich hast du dies bei der Bestellung ausgewählt.</p>' +
            '<br/>' +
            '<p>Du kannst den kompletten Monat im vollen Umfang nutzen und deine Chancen bei der Wohnungssuche erhöhen.</p>' +
            '<br/>' +
            '<p>Die Plus-Mitgliedschaft enthält folgende Vorteile:</p>' +
            '<ul>' +
            '<li> Chancen-Analyse</li>' +
            '<li> Ihre Kontaktanfrage oben</li>' +
            '<li> Exklusive Anzeigen frühzeitig kontaktieren</li>' +
            '<li> Hochwertige Bewerbermappe</li>' +
            '<li> Mietkautionsbürgschaft</li>' +
            '<li> SCHUFA-BonitätsCheck monatlich</li>' +
            '<li> Mietzahlungs-/ Einkommensnachweise</li>' +
            '<li> Mietrechtsberatung</li>' +
            '<li> Schlüsselnotdienst</li>' +
            '<li> Nebenkosten-Check</li>' +
            '</ul>',
        },
        livingBundle: {
          title: 'Wie kann ich meine Wohnen+ Mitgliedschaft nutzen?',
          description:
            'Mit der Wohnen+ Mitgliedschaft stehen dir viele Vorteile zur Verfügung, die dich bei der Suche nach einem Mietobjekt unterstützen. Dazu gehören ein rabattierter SCHUFA-BonitätsCheck, die ImmoScout24-Bonitätsauskunft, die Bewerbermappe, exklusive Anzeigen, deine Anfrage ganz oben im Postfach der Anbietenden sowie der Chancen-Check.',
        },
        mieterPlus: {
          title: 'Wie kann ich meine Suchen+ für Miete Mitgliedschaft nutzen?',
          description:
            'Mit der Suchen+ für Miete Mitgliedschaft stehen dir viele Vorteile zur Verfügung, die dich bei der Suche nach einem Mietobjekt unterstützen. Dazu gehören ein rabattierter SCHUFA-BonitätsCheck, die ImmoScout24-Bonitätsauskunft, die Bewerbermappe, exklusive Anzeigen, deine Anfrage ganz oben im Postfach der Anbietenden sowie der Chancen-Check.',
        },
        wohnenPlusLight: {
          title: 'Wie kann ich meine Wohnen+ Light Mitgliedschaft nutzen?',
          description:
            'Mit der Wohnen+ Light Mitgliedschaft stehen dir ausgewählte Vorteile zur Verfügung. Dazu gehören der Nebenkosten-Check, Lagerraum-Service, MagentaTV und Klarwatt Ökostrom.',
        },
        kaeuferPlus: {
          title: 'Wo finde ich Informationen zum Preis und Laufzeit meiner Mitgliedschaft?',
          description:
            'Informationen zu der gebuchten Plus-Mitgliedschaft, wie der monatliche Preis, die gewählte Zahlmethode und die Mindestlaufzeit können {Link} eingesehen werden.',
          linkText: 'hier',
          linkTitle: 'Zu meinen Einstellungen',
        },
      },
      section3: {
        premium: {
          title: 'Kann ich auch eine Rechnung für meine Plus-Mitgliedschaft erhalten?',
          description:
            '<p>Ja, Rechnungen deiner Mitgliedschaft findest du unter Konto verwalten > Meine Rechnungen.</p>',
        },
        livingBundle: {
          title: 'Kann ich auch eine Rechnung für meine Plus-Mitgliedschaft erhalten?',
          description:
            '<p>Ja, Rechnungen deiner Mitgliedschaft findest du unter Konto verwalten > Meine Rechnungen.</p>',
        },
        mieterPlus: {
          title: 'Kann ich auch eine Rechnung für meine Plus-Mitgliedschaft erhalten?',
          description:
            '<p>Ja, Rechnungen deiner Mitgliedschaft findest du unter Konto verwalten > Meine Rechnungen.</p>',
        },
        wohnenPlusLight: {
          title: 'Kann ich auch eine Rechnung für meine Wohnen+ Light Mitgliedschaft erhalten?',
          description:
            '<p>Ja, Rechnungen deiner Mitgliedschaft findest du unter Konto verwalten > Meine Rechnungen.</p>',
        },
        kaeuferPlus: {
          title: 'Kann ich eine Rechnung für meine Plus-Mitgliedschaft erhalten?',
          description:
            'Aktuell können wir leider keine Rechnung über die Buchung der Plus-Mitgliedschaft ausstellen.<br/><br/>Bitte nutze alternativ die Buchungsbelege zu der Zahlung (von PayPal, deiner Bank oder deinem Kreditkarteninstitut).',
        },
      },
    },
    linkText: 'Weitere Fragen',
    linkTitle: 'Zu häufigen Fragen für Suchende',
  },
  customerService: {
    headline: 'Weitere Fragen?',
    text: 'Falls du Fragen hast steht unser Kundenservice dir gerne zur Verfügung:',
    eMail: 'service@immobilienscout24.de',
  },
  voucherUpsellBanner: {
    title: 'Internationaler Frauentag: Mehr Mietsicherheit schenken',
    message:
      'Jetzt 30 % Rabatt auf Wohnen+ verschenken – für mehr Mietsicherheit, attraktive Partnervorteile und einen kostenfreien Nebenkosten-Check. Gültig bis 20.03.2026.',
    vibrant: {
      title: 'Internationaler Frauentag: Mehr Mietsicherheit schenken',
      message:
        'Jetzt 30 % Rabatt auf Wohnen+ verschenken – für mehr Mietsicherheit, attraktive Partnervorteile und einen kostenfreien Nebenkosten-Check. Gültig bis 20.03.2026.',
    },
    cta: 'Gutschein jetzt verschenken',
    ctaWithoutWohnenPlus: 'Wohnen+ kaufen und Gutschein verschenken',
    modal: {
      title: 'Internationaler Frauentag: Mehr Mietsicherheit schenken',
      description: 'Teile jetzt den Gutscheincode für 30% auf Wohnen+ S mit einer Person deiner Wahl.',
      codeLabel: 'Dein Gutscheincode',
      shareButton: 'Gutscheincode teilen',
      shareTitle: 'Internationaler Frauentag: 30 % Rabatt auf Wohnen+',
      shareText:
        'Hey!\n\nIch schenke dir 30 % Rabatt auf Wohnen+ So sicherst du dich und dein Zuhause ab und profitierst zusätzlich von exklusiven Partnervorteilen wie MagentaTV, KlarWatt und sogar einem kostenfreien Nebenkosten-Check.\n\nDein Code: {code}\n\nHier Rabatt freischalten: {url}\n\nDie Aktion läuft bis 20.03.2026. Der Gutschein gilt ausschließlich für neue Wohnen+ Kund:innen und muss bis spätestens 20.03.2026 eingelöst werden. Er kann nur einmal verwendet werden. Der Rabatt gilt nur für die erste Laufzeit von 12 Monaten der Wohnen+ S Mitgliedschaft. Ohne Kündigung verlängert sich die Mitgliedschaft automatisch zum regulären Preis. Die Kündigungsfrist beträgt 1 Monat. Eine rückwirkende Anrechnung auf bereits abgeschlossene Buchungen sowie eine Barauszahlung oder Übertragung des Gutscheins sind ausgeschlossen.',
      validityInfo:
        'Die Aktion läuft bis 20.03.2026. Der Gutschein gilt ausschließlich für neue Wohnen+ Kund:innen und muss bis spätestens 20.03.2026 eingelöst werden. Er kann nur einmal verwendet werden.\nDer Rabatt gilt nur für die erste Laufzeit von 12 Monaten der Wohnen+ S Mitgliedschaft. Ohne Kündigung verlängert sich die Mitgliedschaft automatisch zum regulären Preis. Die Kündigungsfrist beträgt 1 Monat. Eine rückwirkende Anrechnung auf bereits abgeschlossene Buchungen sowie eine Barauszahlung oder Übertragung des Gutscheins sind ausgeschlossen.',
    },
  },
};

export default de;
